import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import UploadImgIcon from "../../../Assets/Images/EployeeRegistration/icon-image.png";
import PreviewModal from "../PreviewModel";
import CropperModal from "../Cropper";
import SearchDropdown from "../../OTC/dropdownInput";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import { fetchGenderData } from "../../../Redux/EmployeeRegistration/genderSlice";
import { fetchCategorynData } from "../../../Redux/EmployeeRegistration/categorySlice";
import { fetchSubCategorynData } from "../../../Redux/StudentRegistration/subcategorySlice";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import { fetchCoachingData } from "../../../Redux/StudentRegistration/coachingSlice";
import { fetchStateData } from "../../../Redux/StudentRegistration/stateSlice";
import { fetchClassTypeData } from "../../../Redux/StudentRegistration/classTypeSlice";
import { fetchSchoolNameData } from "../../../Redux/StudentRegistration/schoolSlice";
import { fetchClassData } from "../../../Redux/StudentRegistration/classSlice";
import { fetchMediumData } from "../../../Redux/StudentRegistration/mediumSlice";
import { fetchBoardData } from "../../../Redux/StudentRegistration/boardSlice";
import SchoolSearch from "../SchoolSearch";
import EndPoints from "../../../Api/EndPoints";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
import WarningImg from "../../../Assets/Images/CommanImages/Warning.png";
import WarningIcon from "../../../Assets/Images/CommanImages/Warning.png";
import SelectDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import studentDummyData from "./studentDummyData.json";
import SearchSelectedValues from "./SearchSelectedValues";
import SearchSelectedSchool from "./SearchSelectedSchool";
import useFieldChangeTracker from "../../../Utils/TrackData/TrackData";

function StudentRegEdit({
  dataClient,
  setMessageBox,
  setIsMessageBoxVisible,
  setMessageBoxHeight,
  setActiveImg,
  setNoTimeSet,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const studentIdFromUrl = searchParams.get("studentId");
  const { statedata, loading, error } = useSelector((state) => state.domstate);
  const { subcategorydata } = useSelector((state) => state.subcategoies);
  const { genderdata } = useSelector((state) => state.gender);
  const { categorydata } = useSelector((state) => state.categories);
  const { coursesdata } = useSelector((state) => state.course);
  const { coachingData } = useSelector((state) => state.coaching);
  const { classtypedata } = useSelector((state) => state.classType);
  const { schoolnamedata } = useSelector((state) => state.schoolname);
  const { classData } = useSelector((state) => state.classname);
  const { mediumData } = useSelector((state) => state.medium);
  const { boardData } = useSelector((state) => state.board);
  const [customFields, setCustomFields] = useState({
    custom_field_1: "",
    custom_field_2: "",
    custom_field_3: "",
    custom_field_4: "",
    custom_field_5: "",
    custom_field_6: "",
  });
  const [isCustomOpen, setIsCustomOpen] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [selectedGenderName, setSelectedGenderName] = useState("");
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [selectedSubCategoryName, setSelectedSubCategoryName] = useState("");
  const [selectedCoachingName, setSelectedCoachingName] = useState("");
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedMediumName, setSelectedMediumName] = useState("");
  const [selectedIncomeName, setSelectedIncomeName] = useState("");
  const [selectedFatherIncomeName, setSelectedFatherIncomeName] = useState("");
  const [selectedLocalCityName, setSelectedLocalCityName] = useState("");
  const [selectedPermCityName, setSelectedPermCityName] = useState("");
  const [selectedPreviousCoachingName, setSelectedPreviousCoachingName] =
    useState("");
  const [rollNumberErrors, setRollNumberErrors] = useState([]);
  const [address, setAddress] = useState({});
  const [educationDetails, setEducationDetails] = useState({});
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isEduOpen, setIsEduOpen] = useState(false);
  const [selectedSchoolName, setSelectedSchoolName] = useState("");
  const [isAddressOpen, setIsAddressOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCity, setFilteredCity] = useState([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const searchContainerRef = useRef(null);
  const [searchPermCity, setSearchPermCity] = useState("");
  const [filteredPermCity, setFilteredPermCity] = useState([]);
  const searchPermCityRef = useRef(null);
  const [sameAsLocal, setSameAsLocal] = useState(true);
  const [localCityOptions, setLocalCityOptions] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [stateName, setStateName] = useState("");
  const [permCityOptions, setPermCityOptions] = useState([]);
  const [selectedPermCity, setSelectedPermCity] = useState(null);
  const [stateNamePerm, setStateNamePerm] = useState("");
  const [isGuardianOpen, setIsGuardianOpen] = useState(false);
  const [gaurdianInfo, setGaurdianInfo] = useState({
    fathers_name: "",
    fathers_occupation: "",
    fathers_designation: "",
    fathers_annual_income: "",
    fathers_email_id: "",
    fathers_mob_no: "",
    mothers_name: "",
    mothers_occupation: "",
    mothers_designation: "",
    mothers_annual_income: "",
    mothers_email_id: "",
    mothers_mob_no: "",
    guardian_name: "",
    guardian_mob_no: "",
    guardian_relation: null,
    comments_: "",
  });
  const [personalInfo, setPersonalInfo] = useState({
    enquiry_id: null,
    roll_number: "",
    class_type_id: null,
    student_first_name: "",
    student_middle_name: "",
    student_last_name: "",
    date_of_birth: "",
    gender_id: 0,
    aadhaar_no: "",
    category_id: null,
    sub_category_id: null,
    domicile_city_id: 0,
    student_mob_no: "",
    email_id: "",
    emrgency_contact_mob_no: "",
    course_id: null,
    last_coaching_id: null,
    delete_flag: 0,
    photograph: "",
  });
  const [croppedImageBlob, setCroppedImageBlob] = useState(null);
  const [image, setImage] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [fileName, setFileName] = useState("No selected file");
  const [src, setSrc] = useState(null);
  const cropperRef = useRef(null);
  const [isOpen, setIsOpen] = useState(true);
  const [rollNumberMessage, setRollNumberMessage] = useState("");
  // Landing passes the redux `landing.data` object directly as `dataClient`,
  // so client_schema_name is at the top level (no extra `.dataClient`).
  const clientInfo = dataClient?.client_schema_name?.[6]?.[0];
  const client_id = clientInfo?.client_id;
  const user_name = clientInfo?.user_name;
  const client_branch_id = clientInfo?.client_branch_id;
  const accessToken = localStorage.getItem("other");
  const [isEditMode, setIsEditMode] = useState(false);

  // ─── NEW: originalData state to track baseline for diffing ───────────────
  const [originalData, setOriginalData] = useState({
    personalInfo: {},
    educationDetails: {},
    address: {},
    gaurdianInfo: {},
    customFields: {},
    photograph: null,
  });
  // ─────────────────────────────────────────────────────────────────────────

  const fetchStudentDataByStudentId = async (studentId) => {
    try {
      const accessToken = localStorage.getItem("other");
      const response = await fetch(
        `${FULL_API_BASE_URL}/get-student-reg-details/?student_id=${studentId}`,
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch student data");
      }
      const data = await response.json();
      await populateFormData(data);
    } catch (error) {
      console.error("Error fetching student data:", error);
      showErrorMessage(["Failed to load student data. Please try again."]);
    }
  };

  const populateFormData = async (data) => {
    const personalInfoData = {
      enquiry_id: data.enquiry_id || null,
      roll_number: data.roll_number || "",
      class_type_id: data.class_type_id || null,
      student_first_name: data.student_first_name || "",
      student_middle_name: data.student_middle_name || "",
      student_last_name: data.student_last_name || "",
      date_of_birth: data.date_of_birth || "",
      gender_id: data.gender_id || 0,
      aadhaar_no: data.aadhaar_no || "",
      category_id: data.category_id || null,
      sub_category_id: data.sub_category_id || null,
      domicile_city_id: data.domicile_city_id || 0,
      student_mob_no: data.student_mob_no || "",
      email_id: data.email_id || "",
      emrgency_contact_mob_no: data.emrgency_contact_mob_no || "",
      course_id: data.course_id || null,
      last_coaching_id: data.last_coaching_id || null,
      delete_flag: 0,
      photograph: data.photograph || "",
    };

    const educationDetailsData = {
      last_school_id: data.last_school_id || null,
      current_class_id: data.current_class_id || null,
      education_medium_id: data.education_medium_id || null,
      board_id_5: data.board_id_5 || null,
      pass_year_5: data.pass_year_5 || "",
      school_name_5: data.school_name_5 || "",
      percentage_cgpa_5: data.percentage_cgpa_5 || "",
      board_id_6: data.board_id_6 || null,
      pass_year_6: data.pass_year_6 || "",
      school_name_6: data.school_name_6 || "",
      percentage_cgpa_6: data.percentage_cgpa_6 || "",
      board_id_7: data.board_id_7 || null,
      pass_year_7: data.pass_year_7 || "",
      school_name_7: data.school_name_7 || "",
      percentage_cgpa_7: data.percentage_cgpa_7 || "",
      board_id_8: data.board_id_8 || null,
      pass_year_8: data.pass_year_8 || "",
      school_name_8: data.school_name_8 || "",
      percentage_cgpa_8: data.percentage_cgpa_8 || "",
      board_id_9: data.board_id_9 || null,
      pass_year_9: data.pass_year_9 || "",
      school_name_9: data.school_name_9 || "",
      percentage_cgpa_9: data.percentage_cgpa_9 || "",
      board_id_10: data.board_id_10 || null,
      pass_year_10: data.pass_year_10 || "",
      school_name_10: data.school_name_10 || "",
      percentage_cgpa_10: data.percentage_cgpa_10 || "",
      board_id_11: data.board_id_11 || null,
      pass_year_11: data.pass_year_11 || "",
      school_name_11: data.school_name_11 || "",
      percentage_cgpa_11: data.percentage_cgpa_11 || "",
      board_id_12: data.board_id_12 || null,
      pass_year_12: data.pass_year_12 || "",
      school_name_12: data.school_name_12 || "",
      percentage_cgpa_12: data.percentage_cgpa_12 || "",
    };

    const addressData = {
      loc_add1: data.loc_add1 || "",
      loc_add2: data.loc_add2 || "",
      loc_city_id: data.loc_city_id || null,
      loc_pincode: data.loc_pincode || "",
      perm_add1: data.perm_add1 || "",
      perm_add2: data.perm_add2 || "",
      perm_city_id: data.perm_city_id || null,
      perm_pincode: data.perm_pincode || "",
    };

    const gaurdianInfoData = {
      fathers_name: data.fathers_name || "",
      fathers_occupation: data.fathers_occupation || "",
      fathers_designation: data.fathers_designation || "",
      fathers_annual_income: data.fathers_annual_income || "",
      fathers_email_id: data.fathers_email_id || "",
      fathers_mob_no: data.fathers_mob_no || "",
      mothers_name: data.mothers_name || "",
      mothers_occupation: data.mothers_occupation || "",
      mothers_designation: data.mothers_designation || "",
      mothers_annual_income: data.mothers_annual_income || "",
      mothers_email_id: data.mothers_email_id || "",
      mothers_mob_no: data.mothers_mob_no || "",
      guardian_name: data.guardian_name || "",
      guardian_mob_no: data.guardian_mob_no || "",
      guardian_relation: data.guardian_relation || null,
      comments_: data.comments_ || "",
    };

    const customFieldsData = {
      custom_field_1: data.custom_field_1 || "",
      custom_field_2: data.custom_field_2 || "",
      custom_field_3: data.custom_field_3 || "",
      custom_field_4: data.custom_field_4 || "",
      custom_field_5: data.custom_field_5 || "",
      custom_field_6: data.custom_field_6 || "",
    };

    // Set all form states
    setPersonalInfo(personalInfoData);
    setEducationDetails(educationDetailsData);
    // Decide "Same as Local Address" from the saved data. It defaults to true, and the
    // auto-uncheck effect below WIPES the permanent address when local != permanent,
    // so a student whose permanent address differs from the local one lost it on load.
    // Set it BEFORE setAddress so the effect never sees checked + differing addresses.
    const normalize = (v) => String(v ?? "").trim();
    const isSameAsLocal =
      normalize(addressData.loc_add1) === normalize(addressData.perm_add1) &&
      normalize(addressData.loc_add2) === normalize(addressData.perm_add2) &&
      normalize(addressData.loc_pincode) === normalize(addressData.perm_pincode) &&
      normalize(addressData.loc_city_id) === normalize(addressData.perm_city_id);
    setSameAsLocal(isSameAsLocal);
    setAddress(addressData);
    setGaurdianInfo(gaurdianInfoData);
    setCustomFields(customFieldsData);

    // ─── NEW: Save original data snapshot for change tracking ──────────────
    setOriginalData({
      personalInfo: { ...personalInfoData },
      educationDetails: { ...educationDetailsData },
      address: { ...addressData },
      gaurdianInfo: { ...gaurdianInfoData },
      customFields: { ...customFieldsData },
      photograph: data.photograph || null,
    });
    // ────────────────────────────────────────────────────────────────────────

    // Set dropdown display names
    if (data.course_id && coursesdata) {
      const course = coursesdata.find((c) => c.course_id === data.course_id);
      setSelectedCourseName(course?.course_description || "");
    }
    if (data.gender_id && genderdata) {
      const gender = genderdata.find((g) => g.gender_id === data.gender_id);
      setSelectedGenderName(gender?.gender_name || "");
    }
    if (data.category_id && categorydata) {
      const category = categorydata.find(
        (c) => c.category_id === data.category_id
      );
      setSelectedCategoryName(category?.category_desc || "");
    }
    if (data.sub_category_id && subcategorydata) {
      const subCategory = subcategorydata.find(
        (s) => s.sub_category_id === data.sub_category_id
      );
      setSelectedSubCategoryName(subCategory?.sub_category_desc || "");
    }
    if (data.last_coaching_id && coachingData) {
      const coaching = coachingData.find(
        (c) => c.institute_id === data.last_coaching_id
      );
      setSelectedCoachingName(coaching?.institute_name || "");
      setSelectedPreviousCoachingName(coaching?.institute_name || "");
    }
    if (data.current_class_id && classData) {
      const classItem = classData.find(
        (cls) => cls.class_id === data.current_class_id
      );
      setSelectedClassName(classItem?.class_name || "");
    }
    if (data.education_medium_id && mediumData) {
      const medium = mediumData.find(
        (med) => med.medium_id === data.education_medium_id
      );
      setSelectedMediumName(medium?.medium_desc || "");
    }

    // Fetch local city details
    if (data.loc_city_id) {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${data.city_name}`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        const cities = await response.json();
        const city = cities.find((c) => c.city_id === data.loc_city_id);

        if (city) {
          setSelectedLocalCityName(city.city_name);
          setSearchTerm(city.city_name);
          setStateName(city.state_name || "");
          setSelectedCity(city);
        } else {
          setSelectedLocalCityName(data.city_name || "");
          setSearchTerm(data.city_name || "");
          setSelectedCity({
            city_id: data.loc_city_id,
            city_name: data.city_name || "",
          });
        }
      } catch (error) {
        console.error("Error fetching local city details:", error);
        setSelectedLocalCityName(data.city_name || "");
        setSearchTerm(data.city_name || "");
        setSelectedCity({
          city_id: data.loc_city_id,
          city_name: data.city_name || "",
        });
      }
    }

    // Fetch permanent city details
    if (data.perm_city_id) {
      try {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${data.city_name}`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        );
        const cities = await response.json();
        const city = cities.find((c) => c.city_id === data.perm_city_id);

        if (city) {
          setSelectedPermCityName(city.city_name);
          setSearchPermCity(city.city_name);
          setStateNamePerm(city.state_name || "");
          setSelectedPermCity(city);
        } else {
          setSelectedPermCityName(data.city_name || "");
          setSearchPermCity(data.city_name || "");
          setSelectedPermCity({
            city_id: data.perm_city_id,
            city_name: data.city_name || "",
          });
        }
      } catch (error) {
        console.error("Error fetching permanent city details:", error);
        setSelectedPermCityName(data.city_name || "");
        setSearchPermCity(data.city_name || "");
        setSelectedPermCity({
          city_id: data.perm_city_id,
          city_name: data.city_name || "",
        });
      }
    }

    if (data.school_name) {
      setSelectedSchoolName(data.school_name);
    }

    if (data.photograph) {
      setImage(data.photograph);
      setFileName("student_photo.jpg");
    }

    const incomeOptions = [
      { label: "0 To Rs 2,00,000", id: "1" },
      { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
      { label: "Rs 400000 To Rs 6,00,000", id: "3" },
      { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
      { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
      { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
      { label: "> Rs 15,00,000", id: "7" },
      { label: "Not Available", id: "8" },
    ];
    if (data.fathers_annual_income) {
      const fatherIncome = incomeOptions.find(
        (opt) => opt.id === data.fathers_annual_income
      );
      setSelectedFatherIncomeName(fatherIncome?.label || "");
    }
    if (data.mothers_annual_income) {
      const motherIncome = incomeOptions.find(
        (opt) => opt.id === data.mothers_annual_income
      );
      setSelectedIncomeName(motherIncome?.label || "");
    }
  };

  // ─── NEW: Helper — diff current state vs originalData, return only changed fields ──
  const getChangedFields = () => {
    const changed = {};

    // Compare personalInfo (skip image keys — handled separately)
    Object.keys(originalData.personalInfo).forEach((key) => {
      if (key === "photograph" || key === "IMG") return;
      const currentVal =
        personalInfo[key] === undefined ? null : personalInfo[key];
      const originalVal =
        originalData.personalInfo[key] === undefined
          ? null
          : originalData.personalInfo[key];
      if (String(currentVal) !== String(originalVal)) {
        changed[key] = personalInfo[key];
      }
    });

    // Compare educationDetails
    Object.keys(educationDetails).forEach((key) => {
      const currentVal =
        educationDetails[key] === undefined ? null : educationDetails[key];
      const originalVal =
        originalData.educationDetails[key] === undefined
          ? null
          : originalData.educationDetails[key];
      if (String(currentVal) !== String(originalVal)) {
        changed[key] = educationDetails[key];
      }
    });

    // Compare address
    Object.keys(address).forEach((key) => {
      const currentVal = address[key] === undefined ? null : address[key];
      const originalVal =
        originalData.address[key] === undefined
          ? null
          : originalData.address[key];
      if (String(currentVal) !== String(originalVal)) {
        changed[key] = address[key];
      }
    });

    // Compare gaurdianInfo
    Object.keys(gaurdianInfo).forEach((key) => {
      const currentVal =
        gaurdianInfo[key] === undefined ? null : gaurdianInfo[key];
      const originalVal =
        originalData.gaurdianInfo[key] === undefined
          ? null
          : originalData.gaurdianInfo[key];
      if (String(currentVal) !== String(originalVal)) {
        changed[key] = gaurdianInfo[key];
      }
    });

    // Compare customFields
    Object.keys(customFields).forEach((key) => {
      const currentVal =
        customFields[key] === undefined ? "" : customFields[key];
      const originalVal =
        originalData.customFields[key] === undefined
          ? ""
          : originalData.customFields[key];
      if (String(currentVal) !== String(originalVal)) {
        changed[key] = customFields[key];
      }
    });

    return changed;
  };

  // ─── Audit Logging Function ──────────────────────────────────────────────
  const createAuditLog = async (changedFields) => {
    try {
      const clientData = dataClient?.client_schema_name?.[6]?.[0];
      const currentBranchId = clientData?.client_branch_id;
      const currentUserName = clientData?.user_name;
      const currentAccessToken = localStorage.getItem("other");

      const changes = [];

      // Helper to find old value across all original data objects
      const getOldValue = (key) => {
        if (originalData.personalInfo.hasOwnProperty(key)) {
          return originalData.personalInfo[key];
        }
        if (originalData.educationDetails.hasOwnProperty(key)) {
          return originalData.educationDetails[key];
        }
        if (originalData.address.hasOwnProperty(key)) {
          return originalData.address[key];
        }
        if (originalData.gaurdianInfo.hasOwnProperty(key)) {
          return originalData.gaurdianInfo[key];
        }
        if (originalData.customFields.hasOwnProperty(key)) {
          return originalData.customFields[key];
        }
        return null;
      };

      Object.keys(changedFields).forEach((key) => {
        const oldValue = getOldValue(key);
        const newValue = changedFields[key];

        changes.push({
          column_name: key,
          old_value: String(oldValue ?? ""),
          new_value: String(newValue ?? ""),
        });
      });

      // Add photograph change if applicable
      if (croppedImageBlob) {
        changes.push({
          column_name: "photograph",
          old_value: originalData.photograph ? "existing_photo" : "",
          new_value: "photo_updated",
        });
      }
      if (changes.length === 0) {
        console.log("No changes to audit");
        return;
      }

      const auditPayload = {
        client_branch_id: currentBranchId,
        screen_id: 11,
        user_name: currentUserName,
        changes: changes,
      };

      const response = await fetch(
        `${FULL_API_BASE_URL}/create-transaction-audit`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${currentAccessToken}`,
          },
          body: JSON.stringify(auditPayload),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("❌ Audit API Error:", errorData);
      } else {
        const responseData = await response.json();
        console.log("✅ Audit log created successfully:", responseData);
      }
    } catch (error) {
      console.error("❌ Error creating audit log:", error);
    }
  };

  useEffect(() => {
    if (studentIdFromUrl) {
      if (
        genderdata?.length > 0 &&
        categorydata?.length > 0 &&
        subcategorydata?.length > 0 &&
        coursesdata?.length > 0 &&
        coachingData?.length > 0 &&
        classData?.length > 0 &&
        mediumData?.length > 0 &&
        boardData?.length > 0
      ) {
        fetchStudentDataByStudentId(studentIdFromUrl);
      }
    }
  }, [
    studentIdFromUrl,
    genderdata,
    categorydata,
    subcategorydata,
    coursesdata,
    coachingData,
    classData,
    mediumData,
    boardData,
  ]);

  useEffect(() => {
    dispatch(fetchGenderData());
    dispatch(fetchCategorynData());
    dispatch(fetchSubCategorynData());
    dispatch(fetchCourseData());
    dispatch(fetchCoachingData());
    dispatch(fetchStateData());
    dispatch(fetchClassTypeData());
    dispatch(fetchSchoolNameData());
    dispatch(fetchClassData());
    dispatch(fetchMediumData());
    dispatch(fetchBoardData());
  }, [dispatch]);

  useEffect(() => {
    if (studentIdFromUrl) {
      // Edit mode: only flag changes if originalData is loaded AND something actually differs
      const hasOriginalData = Object.keys(originalData.personalInfo).length > 0;
      if (!hasOriginalData) {
        setHasUnsavedChanges(false);
        return;
      }
      const changedFields = getChangedFields();
      setHasUnsavedChanges(
        Object.keys(changedFields).length > 0 || croppedImageBlob !== null
      );
    } else {
      // Create mode: flag if user has typed anything meaningful
      const hasChanges =
        personalInfo.roll_number !== "" ||
        personalInfo.student_first_name !== "" ||
        personalInfo.student_mob_no !== "" ||
        croppedImageBlob !== null ||
        Object.values(customFields).some((val) => val !== "");
      setHasUnsavedChanges(hasChanges);
    }
  }, [
    personalInfo,
    address,
    educationDetails,
    gaurdianInfo,
    croppedImageBlob,
    customFields,
    originalData,
    studentIdFromUrl,
  ]);

  useEffect(() => {
    if (croppedImageBlob) {
      setPersonalInfo((prev) => ({
        ...prev,
        IMG: croppedImageBlob,
      }));
      console.log("Sending image:", {
        imageSize: croppedImageBlob.size,
        imageType: croppedImageBlob.type,
        imageName: croppedImageBlob.name,
      });
    }
  }, [croppedImageBlob]);

  const onChange = (event) => {
    const { name, value } = event.target;
    setPersonalInfo((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "roll_number") {
      const inputElement = event.target;

      const handleBlur = () => {
        if (!value.trim()) return;

        fetch(`${FULL_API_BASE_URL}/check_roll_no/?roll_no=${value.trim()}`)
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 200) {
              setMessageBox(
                <div className="Container-messageBOX">
                  <div className="messagebox-insider1">
                    <div className="loader-tc success"></div>
                    <span>{data.message}</span>
                  </div>
                </div>
              );
              setIsMessageBoxVisible(true);
            }
          })
          .catch((error) => {
            console.error("Error checking roll number:", error);
            setMessageBox(
              <div className="Container-messageBOX">
                <div className="messagebox-insider1">
                  <div className="loader-tc error"></div>
                  <span>Error checking roll number. Please try again.</span>
                </div>
              </div>
            );
            setIsMessageBoxVisible(true);
            setActiveImg(WarningIcon);
          })
          .finally(() => {
            inputElement.removeEventListener("blur", handleBlur);
          });
      };

      inputElement.addEventListener("blur", handleBlur);
    }
  };

  const handleRollNumberBlur = async (e) => {
    const rollNumber = e.target.value.trim();
    setRollNumberErrors([]);
    if (!rollNumber) {
      return;
    }
    // ─── NEW: Skip duplicate check if roll number hasn't changed in edit mode ──
    if (
      studentIdFromUrl &&
      rollNumber === originalData.personalInfo.roll_number
    ) {
      return;
    }
    // ──────────────────────────────────────────────────────────────────────────
    try {
      const result = await checkDuplicateRollNumber(rollNumber);
      if (result.isDuplicate) {
        const newErrors = [
          "This roll number is already registered, please use a different roll number",
        ];
        setRollNumberErrors(newErrors);
        showErrorMessage(newErrors);
      } else {
        setRollNumberErrors([]);
      }
    } catch (error) {
      console.error("Validation error:", error);
    }
  };

  const handleStateSelect = (selectedOption) => {
    setPersonalInfo((prevValues) => ({
      ...prevValues,
      domicile_city_id: selectedOption ? selectedOption.state_id : null,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onload = () => {
        setSrc(reader.result);
        setImage(reader.result);
        setShowCropper(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCroppedImage = (croppedFile) => {
    setCroppedImageBlob(croppedFile);
    setImage(URL.createObjectURL(croppedFile));
    setPersonalInfo((prev) => ({
      ...prev,
      photograph: croppedFile,
      IMG: croppedFile,
    }));
    setShowCropper(false);
    setSrc(null);
  };

  const handleDeleteImage = () => {
    setImage(null);
    setSrc(null);
    setFileName("No selected file");
    setCroppedImageBlob(null);
    setPersonalInfo((prev) => ({
      ...prev,
      photograph: null,
      IMG: null,
    }));
    setShowCropper(false);
  };

  const handleCropComplete = async () => {
    if (!cropperRef.current) return;

    try {
      const dataUrl = cropperRef.current.getImage().toDataURL();
      const result = await fetch(dataUrl);
      const blob = await result.blob();

      const timestamp = new Date().getTime();
      const filename = `profile_${timestamp}.jpg`;

      const file = new File([blob], filename, {
        type: "image/jpeg",
        lastModified: Date.now(),
      });

      handleCroppedImage(file);
    } catch (err) {
      console.error("Image processing error:", err);
      showErrorMessage(["Error processing image. Please try again."]);
    }
  };

  const showErrorMessage = (errors) => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <span style={{ whiteSpace: "pre-line" }}>
            {errors.length === 1 ? errors[0] : errors.join("\n")}
          </span>
        </div>
      </div>
    );
    setIsMessageBoxVisible(true);
    setMessageBoxHeight("auto");
    setActiveImg(ErrorImg);
  };

  const showSuccessMessage = (message) => {
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc success"></div>
          <span>{message}</span>
        </div>
      </div>
    );
    setIsMessageBoxVisible(true);
    setHasUnsavedChanges("10vh");
    setActiveImg(InterogativeImg);
  };

  const checkDuplicateRollNumber = async (rollNumber) => {
    try {
      const response = await fetch(
        `${FULL_API_BASE_URL}/check_roll_no/?roll_no=${rollNumber.trim()}`
      );

      const data = await response.json();
      console.log("API Response:", data, "Status:", response.status);

      if (data.status === 200) {
        return {
          isDuplicate: true,
          message: data.message || "This roll number already exists",
        };
      }

      return {
        isDuplicate: false,
        message: "Roll number is available",
      };
    } catch (error) {
      console.error("Error checking roll number:", error);
      return {
        isDuplicate: false,
        message: "Could not validate",
      };
    }
  };

  const validateFormWithErrors = async () => {
    const errors = [];

    if (!personalInfo.roll_number) {
      errors.push("Student Roll Number is required");
    } else {
      // ─── NEW: Skip duplicate check if roll number unchanged in edit mode ──
      const rollUnchanged =
        studentIdFromUrl &&
        personalInfo.roll_number === originalData.personalInfo.roll_number;

      if (!rollUnchanged) {
        try {
          const rollNumberCheck = await checkDuplicateRollNumber(
            personalInfo.roll_number
          );
          if (rollNumberCheck.isDuplicate) {
            errors.push(
              "This roll number is already registered, please use a different roll number"
            );
          }
        } catch (error) {
          console.error("Error checking roll number:", error);
          errors.push("Error validating roll number. Please try again.");
        }
      }
      // ──────────────────────────────────────────────────────────────────────
    }

    if (!personalInfo.class_type_id) {
      errors.push("Class Type is required");
    }
    if (!personalInfo.student_first_name) {
      errors.push("First Name is required");
    }
    if (!personalInfo.date_of_birth) {
      errors.push("Date of Birth is required");
    }
    if (!personalInfo.gender_id || personalInfo.gender_id === 0) {
      errors.push("Gender is required");
    }
    if (!personalInfo.category_id) {
      errors.push("Category is required");
    }
    if (!personalInfo.sub_category_id) {
      errors.push("Sub Category is required");
    }
    if (!personalInfo.student_mob_no) {
      errors.push("Mobile Number is required");
    }
    if (!personalInfo.emrgency_contact_mob_no) {
      errors.push("Emergency Contact Number is required");
    }
    if (!personalInfo.course_id) {
      errors.push("Course is required");
    }
    if (!educationDetails.current_class_id) {
      errors.push("Current Class is required");
    }
    if (!educationDetails.education_medium_id) {
      errors.push("Education Medium is required");
    }
    if (!address.loc_add1) {
      errors.push("Local Address is required");
    }
    if (!address.loc_city_id) {
      errors.push("Local City is required");
    }
    if (!address.perm_add1) {
      errors.push("Permanent Address is required");
    }
    if (!address.perm_city_id) {
      errors.push("Permanent City is required");
    }

    const hasFatherInfo =
      gaurdianInfo.fathers_name && gaurdianInfo.fathers_mob_no;
    const hasMotherInfo =
      gaurdianInfo.mothers_name && gaurdianInfo.mothers_mob_no;

    if (!hasFatherInfo && !hasMotherInfo) {
      errors.push("Please provide either father's or mother's information");
    }

    return errors;
  };

  const clearFormData = () => {
    setPersonalInfo({
      enquiry_id: null,
      roll_number: "",
      class_type_id: null,
      student_first_name: "",
      student_middle_name: "",
      student_last_name: "",
      date_of_birth: "",
      gender_id: 0,
      aadhaar_no: "",
      category_id: null,
      sub_category_id: null,
      domicile_city_id: 0,
      student_mob_no: "",
      email_id: "",
      emrgency_contact_mob_no: "",
      course_id: null,
      last_coaching_id: null,
      delete_flag: 0,
      photograph: "",
    });
    setEducationDetails({});
    setAddress({});
    setGaurdianInfo({});
    setCustomFields({
      custom_field_1: "",
      custom_field_2: "",
      custom_field_3: "",
      custom_field_4: "",
      custom_field_5: "",
      custom_field_6: "",
    });
    setImage(null);
    setCroppedImageBlob(null);
    setHasUnsavedChanges(false);
    // ─── NEW: Reset originalData too ─────────────────────────────────────
    setOriginalData({
      personalInfo: {},
      educationDetails: {},
      address: {},
      gaurdianInfo: {},
      customFields: {},
      photograph: null,
    });
    // ─────────────────────────────────────────────────────────────────────
  };

  const handleSubmit = async () => {
    const errors = await validateFormWithErrors();
    if (errors.length > 0) {
      setShowValidationErrors(true);
      showErrorMessage(errors);
      return;
    }
    setShowValidationErrors(false);
    setShowPreviewModal(true);
  };

  useEffect(() => {
    if (showValidationErrors) {
      const errors = validateFormWithErrors();
      if (errors.length === 0) {
        setShowValidationErrors(false);
      }
    }
  }, [
    personalInfo,
    address,
    educationDetails,
    gaurdianInfo,
    showValidationErrors,
  ]);

  // ─── UPDATED: handleConfirmSubmit — PUT for edit, POST for create ─────────
  const handleConfirmSubmit = async () => {
    try {
      const formData = new FormData();
      const isEditFlow = !!studentIdFromUrl;

      if (isEditFlow) {
        // ── EDIT MODE: PUT request with only changed fields ──────────────────
        const changed = getChangedFields();

        if (Object.keys(changed).length === 0 && !croppedImageBlob) {
          setShowPreviewModal(false);
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                {/* <div className="loader-tc error"></div> */}
                <span>
                  No changes detected. Please modify at least one field before
                  saving.
                </span>
              </div>
            </div>
          );
          setActiveImg(WarningImg);
          setMessageBoxHeight("10vh");
          return;
        }

        // The backend needs to know who edited; never send an edit without it.
        if (!user_name) {
          setShowPreviewModal(false);
          showErrorMessage([
            "Unable to identify the logged-in user. Please refresh the page or log in again.",
          ]);
          return;
        }

        // Always include audit fields
        const editPayload = {
          ...changed,
          last_modified_date: new Date().toISOString(),
          last_modified_by: user_name,
        };

        if (croppedImageBlob) {
          formData.append("photograph", croppedImageBlob);
        }

        formData.append("student_data", JSON.stringify(editPayload));

        const response = await fetch(
          `${FULL_API_BASE_URL}/edit-student/?student_id=${studentIdFromUrl}`,
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            body: formData,
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.detail || errorData.message || "Failed to update student"
          );
        }

        const responseData = await response.json();
        setShowPreviewModal(false);

        // if (responseData.status === 200) {
        //   showSuccessMessage(responseData.message || "Student updated successfully");
        //   setIsEditMode(false);
        //   setActiveImg(false);

        //   // ── NEW: Update originalData baseline so further edits diff correctly ──
        //   setOriginalData({
        //     personalInfo: { ...personalInfo },
        //     educationDetails: { ...educationDetails },
        //     address: { ...address },
        //     gaurdianInfo: { ...gaurdianInfo },
        //     customFields: { ...customFields },
        //     photograph: croppedImageBlob ? image : originalData.photograph,
        //   });
        //   setCroppedImageBlob(null);
        //   // ──────────────────────────────────────────────────────────────────────
        // }

        if (responseData.status === 200) {
          // ─── NEW: Create audit log for changes ──────────────────────────
          await createAuditLog(changed);
          // ────────────────────────────────────────────────────────────────

          // showSuccessMessage(responseData.message || "Student updated successfully");
          showSuccessMessage("Student updated successfully.");
          setIsEditMode(false);
          setActiveImg(false);

          // Update originalData baseline so further edits diff correctly
          setOriginalData({
            personalInfo: { ...personalInfo },
            educationDetails: { ...educationDetails },
            address: { ...address },
            gaurdianInfo: { ...gaurdianInfo },
            customFields: { ...customFields },
            photograph: croppedImageBlob ? image : originalData.photograph,
          });
          setCroppedImageBlob(null);
        } else {
          showErrorMessage([responseData.message || "Update failed"]);
        }
      } else {
        // ── CREATE MODE: POST request with all fields ────────────────────────
        const studentData = {
          ...personalInfo,
          ...educationDetails,
          ...address,
          ...gaurdianInfo,
          ...customFields,
          enquiry_id: personalInfo.enquiry_id || null,
          emergency_contact_name: "Not Available",
          status: 1,
          last_modified_date: new Date().toISOString(),
          last_modified_by: user_name,
          create_date: new Date().toISOString(),
          created_by: user_name,
          client_branch_id: client_branch_id,
          client_id: client_id,
          delete_flag: 0,
          board_id_5: educationDetails.board_id_5 || null,
          pass_year_5: educationDetails.pass_year_5 || "",
          school_name_5: educationDetails.school_name_5 || "",
          percentage_cgpa_5: educationDetails.percentage_cgpa_5 || "",
          board_id_6: educationDetails.board_id_6 || null,
          pass_year_6: educationDetails.pass_year_6 || "",
          school_name_6: educationDetails.school_name_6 || "",
          percentage_cgpa_6: educationDetails.percentage_cgpa_6 || "",
          board_id_7: educationDetails.board_id_7 || null,
          pass_year_7: educationDetails.pass_year_7 || "",
          school_name_7: educationDetails.school_name_7 || "",
          percentage_cgpa_7: educationDetails.percentage_cgpa_7 || "",
          board_id_8: educationDetails.board_id_8 || null,
          pass_year_8: educationDetails.pass_year_8 || "",
          school_name_8: educationDetails.school_name_8 || "",
          percentage_cgpa_8: educationDetails.percentage_cgpa_8 || "",
          board_id_9: educationDetails.board_id_9 || null,
          pass_year_9: educationDetails.pass_year_9 || "",
          school_name_9: educationDetails.school_name_9 || "",
          percentage_cgpa_9: educationDetails.percentage_cgpa_9 || "",
          board_id_10: educationDetails.board_id_10 || null,
          pass_year_10: educationDetails.pass_year_10 || "",
          school_name_10: educationDetails.school_name_10 || "",
          percentage_cgpa_10: educationDetails.percentage_cgpa_10 || "",
          board_id_11: educationDetails.board_id_11 || null,
          pass_year_11: educationDetails.pass_year_11 || "",
          school_name_11: educationDetails.school_name_11 || "",
          percentage_cgpa_11: educationDetails.percentage_cgpa_11 || "",
          board_id_12: educationDetails.board_id_12 || null,
          pass_year_12: educationDetails.pass_year_12 || "",
          school_name_12: educationDetails.school_name_12 || "",
          percentage_cgpa_12: educationDetails.percentage_cgpa_12 || "",
          guardian_name: gaurdianInfo.guardian_name || "",
          guardian_mob_no: gaurdianInfo.guardian_mob_no || "",
          guardian_relation: gaurdianInfo.guardian_relation || null,
          comments_: gaurdianInfo.comments_ || "",
        };

        if (personalInfo.IMG) {
          const { IMG, ...dataWithoutImage } = studentData;
          formData.append("photograph", personalInfo.IMG);
          formData.append("student_data", JSON.stringify(dataWithoutImage));
        } else {
          formData.append("student_data", JSON.stringify(studentData));
        }

        const response = await fetch(`${EndPoints.NEW_STUDENT_REGISTRATION}`, {
          method: "POST",
          body: formData,
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.detail || errorData.message || "Failed to submit form"
          );
        }

        const responseData = await response.json();
        setShowPreviewModal(false);

        if (responseData.result === "success") {
          showSuccessMessage(
            responseData.message || "Student registered successfully"
          );
          clearFormData();
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          showErrorMessage([responseData.message || "Registration failed"]);
        }
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setShowPreviewModal(false);
      showErrorMessage([error.message || "Error submitting form"]);
    }
  };
  // ─────────────────────────────────────────────────────────────────────────────

  const onCustomFieldChange = (e) => {
    const { name, value } = e.target;
    setCustomFields({ ...customFields, [name]: value });
  };

  const toggleCustomAccordion = () => {
    setIsCustomOpen(!isCustomOpen);
  };

  const handleCancel = () => {
    if (hasUnsavedChanges) {
      if (setMessageBox && setIsMessageBoxVisible) {
        if (setMessageBoxHeight) {
          setMessageBoxHeight("10vh");
        }

        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>You have unsaved changes. Do you want to continue?</span>
            </div>
            <div
              className="messagebox-insider2"
              style={{ display: "flex", gap: "10px", marginTop: "10px" }}
            >
              <button
                className="messagebox-cancel-btn-ok"
                onClick={() => {
                  clearFormData();
                  setIsMessageBoxVisible(false);
                  navigate("/studentdashboard");
                }}
              >
                YES
              </button>
              <button
                className="messagebox-cancel-btn-ok"
                onClick={() => {
                  setIsMessageBoxVisible(false);
                }}
              >
                NO
              </button>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(WarningIcon);
      }
    } else {
      navigate("/studentdashboard");
    }
  };

  const handleSchoolSelect = (school) => {
    if (!school) {
      setEducationDetails((prevInfo) => ({
        ...prevInfo,
        last_school_id: null,
      }));
      setSelectedSchoolName("");
      return;
    }
    setEducationDetails((prevInfo) => ({
      ...prevInfo,
      last_school_id: school.school_id,
    }));
    setSelectedSchoolName(school.school_name);
  };

  const handleEducationChange = (e) => {
    const { name, value } = e.target;
    setEducationDetails((prevInfo) => ({ ...prevInfo, [name]: value }));
  };

  const toggleEducationAccordion = () => {
    setIsEduOpen(!isEduOpen);
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setAddress((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (event) => {
    setSameAsLocal(event.target.checked);
    if (event.target.checked) {
      setAddress((prev) => ({
        ...prev,
        perm_add1: prev.loc_add1,
        perm_add2: prev.loc_add2,
        perm_pincode: prev.loc_pincode,
        perm_city_id: prev.loc_city_id,
      }));
      setSearchPermCity(searchTerm);
      setStateNamePerm(stateName);
      setSelectedPermCity(selectedCity);
    } else {
      setAddress((prev) => ({
        ...prev,
        perm_add1: "",
        perm_add2: "",
        perm_pincode: "",
        perm_city_id: "",
      }));
      setSearchPermCity("");
      setStateNamePerm("");
      setSelectedPermCity(null);
    }
  };

  const handleItemClickOne = (item) => {
    setSelectedCity(item);
    setSearchTerm(item.city_name);
    setStateName(item.state_name);
    setFilteredCity([]);
    setActiveIndex(-1);
    setAddress((prev) => ({
      ...prev,
      loc_city_id: item.city_id,
    }));
  };

  const toggleAddressAccordion = () => {
    setIsAddressOpen(!isAddressOpen);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setActiveIndex(-1);
    if (value.trim() === "") {
      setFilteredCity([]);
      setSelectedCity(null);
      setStateName("");
    } else if (value.length >= 2) {
      handleSearchClick();
    }
  };

  const handleSearchClick = () => {
    if (searchTerm.trim() === "" || searchTerm.length < 2) {
      setFilteredCity([]);
      return;
    }
    setSearchTerm((prevSearchTerm) => {
      fetch(
        `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${encodeURIComponent(
          prevSearchTerm
        )}`
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          const filtered = data.filter((item) =>
            Object.values(item).some(
              (val) =>
                typeof val === "string" &&
                val.toLowerCase().includes(prevSearchTerm.toLowerCase())
            )
          );
          setFilteredCity(filtered);
          setActiveIndex(filtered.length > 0 ? 0 : -1);
        })
        .catch((error) => {
          console.error("Error fetching city list:", error);
        });
      return prevSearchTerm;
    });
  };

  const handleClickOutside = (event) => {
    if (
      searchContainerRef.current &&
      !searchContainerRef.current.contains(event.target)
    ) {
      setFilteredCity([]);
    }
  };

  const fetchLocalCityOptions = (inputText) => {
    if (inputText.trim().length < 2) {
      setLocalCityOptions([]);
      return;
    }
    fetch(
      `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${encodeURIComponent(
        inputText
      )}`
    )
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        setLocalCityOptions(data);
      })
      .catch((error) => {
        console.error("Error fetching local city list:", error);
      });
  };

  const fetchPermCityOptions = (inputText) => {
    if (inputText.trim().length < 2) {
      setPermCityOptions([]);
      return;
    }
    fetch(
      `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${encodeURIComponent(
        inputText
      )}`
    )
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        setPermCityOptions(data);
      })
      .catch((error) => {
        console.error("Error fetching permanent city list:", error);
      });
  };

  const handleClickOutsidePerm = (event) => {
    if (
      searchPermCityRef.current &&
      !searchPermCityRef.current.contains(event.target)
    ) {
      setFilteredPermCity([]);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("click", handleClickOutsidePerm);
    return () => {
      document.removeEventListener("click", handleClickOutsidePerm);
    };
  }, []);

  const handleGuardianChange = (e) => {
    const { name, value } = e.target;
    setGaurdianInfo((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const toggleGuardianAccordion = () => {
    setIsGuardianOpen(!isGuardianOpen);
  };

  const handleGuardianDropdownChange = (fieldName, selectedOption) => {
    setGaurdianInfo((prevValues) => ({
      ...prevValues,
      [fieldName]: selectedOption,
    }));
  };

  const isReadOnly = !!studentIdFromUrl && !isEditMode;

  // Add this useEffect to sync permanent address with local address when "Same as Local" is checked
  // useEffect(() => {
  //   if (sameAsLocal) {
  //     setAddress((prev) => {
  //       // Only update if values actually differ (prevents infinite loop)
  //       if (
  //         prev.perm_add1 !== prev.loc_add1 ||
  //         prev.perm_add2 !== prev.loc_add2 ||
  //         prev.perm_pincode !== prev.loc_pincode ||
  //         prev.perm_city_id !== prev.loc_city_id
  //       ) {
  //         return {
  //           ...prev,
  //           perm_add1: prev.loc_add1,
  //           perm_add2: prev.loc_add2,
  //           perm_pincode: prev.loc_pincode,
  //           perm_city_id: prev.loc_city_id,
  //         };
  //       }
  //       return prev;
  //     });

  //     // Sync city/state display values
  //     if (searchPermCity !== searchTerm) setSearchPermCity(searchTerm);
  //     if (stateNamePerm !== stateName) setStateNamePerm(stateName);
  //     if (selectedPermCity !== selectedCity) setSelectedPermCity(selectedCity);
  //   }
  // }, [
  //   sameAsLocal,
  //   address.loc_add1,
  //   address.loc_add2,
  //   address.loc_pincode,
  //   address.loc_city_id,
  //   searchTerm,
  //   stateName,
  //   selectedCity
  // ]);

  // Auto-uncheck "Same as Local Address" when local address is modified
  useEffect(() => {
    // Only trigger if checkbox is currently checked
    if (sameAsLocal) {
      // Check if local address fields have been modified
      const localCityChanged =
        address.loc_city_id && address.loc_city_id !== address.perm_city_id;
      const localPincodeChanged =
        address.loc_pincode && address.loc_pincode !== address.perm_pincode;
      const localAdd1Changed =
        address.loc_add1 && address.loc_add1 !== address.perm_add1;
      const localAdd2Changed =
        address.loc_add2 && address.loc_add2 !== address.perm_add2;

      // If any local address field changed, uncheck and clear permanent address
      if (
        localCityChanged ||
        localPincodeChanged ||
        localAdd1Changed ||
        localAdd2Changed
      ) {
        setSameAsLocal(false);

        // Clear permanent address fields for fresh input
        setAddress((prev) => ({
          ...prev,
          perm_add1: "",
          perm_add2: "",
          perm_pincode: "",
          perm_city_id: null,
        }));
        setSearchPermCity("");
        setStateNamePerm("");
        setSelectedPermCity(null);
      }
    }
  }, [
    address.loc_city_id,
    address.loc_pincode,
    address.loc_add1,
    address.loc_add2,
  ]);

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Student Registration</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={handleCancel}>
            CANCEL
          </button>
          {/* ─── UPDATED: button logic ─────────────────────────────────────── */}
          {studentIdFromUrl ? (
            isEditMode ? (
              <button className="cr-create-btn" onClick={handleSubmit}>
                SAVE
              </button>
            ) : (
              <button
                className="cr-create-btn"
                onClick={() => setIsEditMode(true)}
              >
                EDIT
              </button>
            )
          ) : (
            <button className="cr-create-btn" onClick={handleSubmit}>
              SUBMIT
            </button>
          )}
          {/* ─────────────────────────────────────────────────────────────── */}
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════════════════════
          PERSONAL INFORMATION
      ══════════════════════════════════════════════════════════════════════ */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>PERSONAL INFORMATION</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordion}>
            {isOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isOpen &&
          classtypedata?.length > 0 &&
          statedata?.length > 0 &&
          coachingData?.length > 0 &&
          coursesdata?.length > 0 &&
          categorydata?.length > 0 &&
          genderdata?.length > 0 &&
          subcategorydata?.length > 0 && (
            <div className="accordion-content">
              <div className="grid-container">
                <div className="item1">
                  <FormInputs
                    label="Enquiry Number"
                    type="text"
                    name="enquiry_id"
                    value={personalInfo.enquiry_id}
                    onChange={onChange}
                    maxlength="50"
                    pattern="[0-9]{1,50}"
                    disabled
                    bg="#d6d6d6"
                  />
                </div>
                <div className="item2" style={{ position: "relative" }}>
                  <FormInputs
                    label="Student Roll Number"
                    type="text"
                    name="roll_number"
                    value={personalInfo.roll_number}
                    onChange={onChange}
                    onBlur={handleRollNumberBlur}
                    maxLength={10}
                    pattern="[A-Za-z,0-9]{1,50}"
                    required
                    showError={showValidationErrors}
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
                <div className="item3">
                  <div className="selecte-dropdown-items">
                    <SelectDropdown
                      label="Class Type"
                      selected={personalInfo.class_type_id}
                      setSelected={(selectedOption) =>
                        setPersonalInfo({
                          ...personalInfo,
                          class_type_id: selectedOption,
                        })
                      }
                      options={[
                        { label: "Online", id: 1 },
                        { label: "Classroom", id: 2 },
                      ]}
                      isRequired={true}
                      showError={showValidationErrors}
                      disabled={isReadOnly} // ← NEW
                    />
                  </div>
                </div>
                <div className="item4">
                  <FormInputs
                    label="First Name"
                    type="text"
                    name="student_first_name"
                    value={personalInfo.student_first_name}
                    onChange={onChange}
                    maxlength="50"
                    pattern="[A-Za-z]{1,50}"
                    required
                    showError={showValidationErrors}
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
                <div className="item5">
                  <FormInputs
                    label="Middle Name"
                    type="text"
                    name="student_middle_name"
                    value={personalInfo.student_middle_name}
                    onChange={onChange}
                    maxlength="50"
                    pattern="[A-Za-z]{1,50}"
                    showError={showValidationErrors}
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
                <div className="item6">
                  <FormInputs
                    label="Last Name"
                    type="text"
                    name="student_last_name"
                    value={personalInfo.student_last_name}
                    onChange={onChange}
                    maxlength="50"
                    pattern="[A-Za-z]{1,50}"
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
                <div className="item7">
                  <FormInputs
                    label="Date of Birth"
                    type="date"
                    name="date_of_birth"
                    value={personalInfo.date_of_birth}
                    onChange={onChange}
                    required
                    showError={showValidationErrors}
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
                <div className="item8">
                  <div className="selecte-dropdown-items">
                    <SelectDropdown
                      label="Gender"
                      selected={personalInfo.gender_id}
                      setSelected={(selectedOption) => {
                        const gender = genderdata.find(
                          (g) => g.gender_id === selectedOption
                        );
                        setSelectedGenderName(gender?.gender_name || "");
                        setPersonalInfo({
                          ...personalInfo,
                          gender_id: selectedOption,
                        });
                      }}
                      options={genderdata.map((gender) => ({
                        label: gender.gender_name,
                        id: gender.gender_id,
                      }))}
                      isRequired={true}
                      showError={showValidationErrors}
                      disabled={isReadOnly} // ← NEW
                    />
                  </div>
                </div>
                <div className="item9">
                  <FormInputs
                    label="Aadhar Number"
                    type="text"
                    name="aadhaar_no"
                    value={personalInfo.aadhaar_no}
                    onChange={onChange}
                    pattern="[0-9]{12}"
                    maxLength={12}
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
                <div className="item10">
                  <div className="selecte-dropdown-items">
                    <SelectDropdown
                      label="Category"
                      selected={personalInfo.category_id}
                      setSelected={(selectedOption) => {
                        const category = categorydata.find(
                          (c) => c.category_id === selectedOption
                        );
                        setSelectedCategoryName(category?.category_desc || "");
                        setPersonalInfo({
                          ...personalInfo,
                          category_id: selectedOption,
                        });
                      }}
                      options={categorydata.map((cat) => ({
                        label: cat.category_desc,
                        id: cat.category_id,
                      }))}
                      isRequired={true}
                      showError={showValidationErrors}
                      disabled={isReadOnly} // ← NEW
                    />
                  </div>
                </div>
                <div className="item11">
                  <div className="selecte-dropdown-items">
                    <SelectDropdown
                      label="Sub Category"
                      selected={personalInfo.sub_category_id}
                      setSelected={(selectedOption) => {
                        const subCategory = subcategorydata.find(
                          (s) => s.sub_category_id === selectedOption
                        );
                        setSelectedSubCategoryName(
                          subCategory?.sub_category_desc || ""
                        );
                        setPersonalInfo({
                          ...personalInfo,
                          sub_category_id: selectedOption,
                        });
                      }}
                      options={subcategorydata.map((subcat) => ({
                        label: subcat.sub_category_desc,
                        id: subcat.sub_category_id,
                      }))}
                      isRequired={true}
                      showError={showValidationErrors}
                      disabled={isReadOnly} // ← NEW
                    />
                  </div>
                </div>
                <div
                  className="item12"
                  style={{
                    gridRowStart: "4",
                    gridRowEnd: "8",
                    gridColumnStart: "3",
                    gridColumnEnd: "3",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <label>Photograph</label>
                    <div className="input-image">
                      <div className="input-image-field">
                        <input
                          type="file"
                          accept="image/*"
                          name="photograph"
                          className="input-field"
                          hidden
                          onChange={handleImageChange}
                          disabled={isReadOnly} // ← NEW
                        />
                        {!showCropper ? (
                          <>
                            {image ? (
                              <div
                                style={{
                                  width: "200px",
                                  height: "200px",
                                  overflow: "hidden",
                                  // border: "1px solid #ccc",
                                  borderRadius: "4px",
                                }}
                              >
                                <img
                                  className="uploaded-img"
                                  src={image}
                                  alt={fileName}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            ) : (
                              <div className="icon-img-container">
                                <img
                                  src={UploadImgIcon}
                                  alt="upload icon"
                                  className="icon-img"
                                />
                              </div>
                            )}
                          </>
                        ) : (
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "300px",
                            }}
                          >
                            <CropperModal src={src} cropperRef={cropperRef} />
                          </div>
                        )}
                      </div>
                      {/* ─── NEW: Hide image buttons in read-only mode ────── */}
                      {!isReadOnly && (
                        <div className="image-btns-container">
                          {showCropper ? (
                            <>
                              <div
                                className="replace-image-btn"
                                style={{ marginBottom: "10px" }}
                                onClick={handleCropComplete}
                              >
                                Save Changes
                              </div>
                              <div
                                className="replace-image-btn"
                                onClick={() =>
                                  document.querySelector(".input-field").click()
                                }
                              >
                                Replace
                              </div>
                              <div
                                className="del-image-btn"
                                onClick={handleDeleteImage}
                              >
                                Delete
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                className="replace-image-btn"
                                onClick={() =>
                                  document.querySelector(".input-field").click()
                                }
                              >
                                {image ? "Replace" : "Upload"}
                              </div>
                              {image && (
                                <div
                                  className="del-image-btn"
                                  onClick={handleDeleteImage}
                                >
                                  Delete
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      )}
                      {/* ───────────────────────────────────────────────────── */}
                    </div>
                  </div>
                </div>
                <div className="item13">
                  <div className="selecte-dropdown-items">
                    <div>
                      <SearchSelectedValues
                        initialOptions={statedata || []}
                        onSelect={handleStateSelect}
                        placeholder="Type to search..."
                        label="Domicile State"
                        labelKey={(option) => option.state_name}
                        initialValue={
                          statedata?.find(
                            (s) => s.state_id === personalInfo.domicile_city_id
                          )?.state_name || ""
                        }
                        disabled={isReadOnly} // ← NEW
                      />
                    </div>
                  </div>
                </div>
                <div className="item14">
                  <FormInputs
                    label="Mobile Number"
                    type="text"
                    name="student_mob_no"
                    value={personalInfo.student_mob_no}
                    onChange={onChange}
                    pattern="[0-9]{10,11}"
                    maxLength={10}
                    required
                    showError={showValidationErrors}
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
                <div className="item15">
                  <FormInputs
                    label="Student Email ID"
                    type="email"
                    name="email_id"
                    value={personalInfo.email_id}
                    onChange={onChange}
                    pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{{2,}}"
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
                <div className="item16">
                  <FormInputs
                    label="Emergency Contact Number"
                    type="text"
                    name="emrgency_contact_mob_no"
                    value={personalInfo.emrgency_contact_mob_no}
                    onChange={onChange}
                    pattern="[0-9]{10,11}"
                    maxLength={10}
                    required
                    showError={showValidationErrors}
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
                <div className="item17">
                  <div className="selecte-dropdown-items">
                    <SelectDropdown
                      label="Course"
                      selected={personalInfo.course_id}
                      setSelected={(selectedOption) => {
                        const course = coursesdata.find(
                          (c) => c.course_id === selectedOption
                        );
                        setSelectedCourseName(course?.course_description || "");
                        setPersonalInfo({
                          ...personalInfo,
                          course_id: selectedOption,
                        });
                      }}
                      options={coursesdata.map((course) => ({
                        label: course.course_description,
                        id: course.course_id,
                      }))}
                      isRequired={true}
                      showError={showValidationErrors}
                      disabled={isReadOnly} // ← NEW
                    />
                  </div>
                </div>
                <div className="item12">
                  <div className="selecte-dropdown-items">
                    <SelectDropdown
                      label="Previous coaching"
                      selected={personalInfo.last_coaching_id}
                      setSelected={(selectedOption) => {
                        const coaching = coachingData.find(
                          (c) => c.institute_id === selectedOption
                        );
                        setSelectedPreviousCoachingName(
                          coaching?.institute_name || ""
                        );
                        setSelectedCoachingName(coaching?.institute_name || "");
                        setPersonalInfo({
                          ...personalInfo,
                          last_coaching_id: selectedOption,
                        });
                      }}
                      options={coachingData.map((coach) => ({
                        label: coach.institute_name,
                        id: coach.institute_id,
                      }))}
                      Height="auto"
                      OverFlow="auto"
                      minheight="300px"
                      disabled={isReadOnly} // ← NEW
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>

      {/* ══════════════════════════════════════════════════════════════════════
          EDUCATION DETAIL
      ══════════════════════════════════════════════════════════════════════ */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>EDUCATION DETAIL</label>
          </div>
          <div className="accordion-btn" onClick={toggleEducationAccordion}>
            {isEduOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isEduOpen &&
          schoolnamedata &&
          classData &&
          mediumData &&
          boardData && (
            <div className="accordion-content">
              <div className="grid-container-education">
                <div className="selecte-dropdown-items">
                  <SearchSelectedSchool
                    onSchoolSelect={handleSchoolSelect}
                    showError={showValidationErrors}
                    isRequired={true}
                    initialValue={selectedSchoolName}
                    disabled={isReadOnly}
                    customWidth="100%"
                    minheight="300px"
                    Height="auto"
                    OverFlow="auto"
                  />
                </div>
                <div className="grid-item">
                  <div className="selecte-dropdown-items">
                    <SelectDropdown
                      label="Class"
                      selected={educationDetails.current_class_id}
                      setSelected={(selectedOption) => {
                        const classItem = classData.find(
                          (cls) => cls.class_id === selectedOption
                        );
                        setSelectedClassName(classItem?.class_name || "");
                        setEducationDetails((prevInfo) => ({
                          ...prevInfo,
                          current_class_id: selectedOption,
                        }));
                      }}
                      options={classData.map((cls) => ({
                        label: cls.class_name,
                        id: cls.class_id,
                      }))}
                      isRequired={true}
                      placeholder="Enter class"
                      showError={showValidationErrors}
                      disabled={isReadOnly} // ← NEW
                    />
                  </div>
                </div>
                <div className="grid-item">
                  <div className="selecte-dropdown-items">
                    <SelectDropdown
                      label="Medium of education"
                      selected={educationDetails.education_medium_id}
                      setSelected={(selectedOption) => {
                        const medium = mediumData.find(
                          (med) => med.medium_id === selectedOption
                        );
                        setSelectedMediumName(medium?.medium_desc || "");
                        setEducationDetails((prevInfo) => ({
                          ...prevInfo,
                          education_medium_id: selectedOption,
                        }));
                      }}
                      options={mediumData.map((med) => ({
                        label: med.medium_desc,
                        id: med.medium_id,
                      }))}
                      isRequired={true}
                      showError={showValidationErrors}
                      disabled={isReadOnly} // ← NEW
                    />
                  </div>
                </div>
              </div>
              <span className="academic-recod-title">Academic record:</span>
              <div className="academic-recode-container">
                <div className="academic-tile">CLASS</div>
                <div className="academic-tile">BOARD</div>
                <div className="academic-tile">YEAR</div>
                <div className="academic-tile">SCHOOL NAME</div>
                <div className="academic-tile">%</div>

                {[5, 6, 7, 8, 9, 10, 11, 12].map((classNum) => (
                  <React.Fragment key={classNum}>
                    <div className="class-name">
                      {classNum === 5
                        ? "V"
                        : classNum === 6
                        ? "VI"
                        : classNum === 7
                        ? "VII"
                        : classNum === 8
                        ? "VIII"
                        : classNum === 9
                        ? "IX"
                        : classNum === 10
                        ? "X"
                        : classNum === 11
                        ? "XI"
                        : "XII"}
                    </div>
                    <div className="data">
                      <div className="selecte-dropdown-items">
                        <SelectDropdown
                          selected={educationDetails[`board_id_${classNum}`]}
                          setSelected={(selectedOption) =>
                            setEducationDetails((prevInfo) => ({
                              ...prevInfo,
                              [`board_id_${classNum}`]: selectedOption,
                            }))
                          }
                          options={boardData.map((bod) => ({
                            label: bod.edu_board_name,
                            id: bod.edu_board_id,
                          }))}
                          disabled={isReadOnly}
                          isRequired={false}
                        />
                      </div>
                    </div>
                    <div className="data">
                      <FormInputs
                        type="text"
                        name={`pass_year_${classNum}`}
                        value={educationDetails[`pass_year_${classNum}`] || ""}
                        onChange={handleEducationChange}
                        maxLength={4}
                        disabled={isReadOnly} // ← NEW
                      />
                    </div>
                    <div className="data">
                      <FormInputs
                        type="text"
                        name={`school_name_${classNum}`}
                        value={
                          educationDetails[`school_name_${classNum}`] || ""
                        }
                        onChange={handleEducationChange}
                        pattern="[A-Za-z, ]{1,50}"
                        disabled={isReadOnly} // ← NEW
                      />
                    </div>
                    <div className="data">
                      <FormInputs
                        type="text"
                        name={`percentage_cgpa_${classNum}`}
                        value={
                          educationDetails[`percentage_cgpa_${classNum}`] || ""
                        }
                        onChange={handleEducationChange}
                        maxLength={2}
                        pattern="[0-9]{1,50}"
                        disabled={isReadOnly} // ← NEW
                      />
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </div>
          )}
      </div>

      {/* ══════════════════════════════════════════════════════════════════════
          ADDRESSES
      ══════════════════════════════════════════════════════════════════════ */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>ADDRESSES</label>
          </div>
          <div className="accordion-btn" onClick={toggleAddressAccordion}>
            {isAddressOpen ? (
              <div className="minus" />
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isAddressOpen && (
          <div className="accordion-content">
            <div className="address-info">
              <div>
                <FormInputs
                  label="Local Address"
                  type="text"
                  name="loc_add1"
                  value={address.loc_add1 || ""}
                  onChange={handleAddressChange}
                  placeholder="Address line 1"
                  maxlength="200"
                  pattern="[A-Za-z0-9-, ]{1,200}"
                  required
                  showError={showValidationErrors}
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div>
                <FormInputs
                  type="text"
                  name="loc_add2"
                  value={address.loc_add2 || ""}
                  onChange={handleAddressChange}
                  placeholder="Address line 2"
                  maxlength="200"
                  pattern="[A-Za-z0-9-, ]{1,200}"
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-container-address">
                <div className="selecte-dropdown-items">
                  <SearchSelectedValues
                    initialOptions={localCityOptions}
                    onInputChange={fetchLocalCityOptions}
                    onSelect={(option) => {
                      if (option) {
                        setSelectedCity(option);
                        setStateName(option.state_name);
                        setSelectedLocalCityName(option.city_name);
                        setAddress((prev) => ({
                          ...prev,
                          loc_city_id: option.city_id,
                        }));
                      } else {
                        setSelectedCity(null);
                        setStateName("");
                        setAddress((prev) => ({
                          ...prev,
                          loc_city_id: 0,
                        }));
                      }
                    }}
                    placeholder="Search..."
                    label="City/District"
                    labelKey={(option) => option.city_name}
                    required={true}
                    showError={showValidationErrors}
                    initialValue={selectedLocalCityName}
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
                <div className="grid-item">
                  <FormInputs
                    label="State"
                    type="text"
                    value={stateName}
                    disabled={selectedCity !== null || isReadOnly} // ← NEW
                    required
                    showError={showValidationErrors}
                  />
                </div>
                <div className="grid-item">
                  <FormInputs
                    label="Pin Code"
                    type="text"
                    name="loc_pincode"
                    value={address.loc_pincode || ""}
                    onChange={handleAddressChange}
                    maxLength={6}
                    pattern="[0-9]{6}"
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
              </div>
              <div
                className="parmanent-add-checkbox"
                style={{ marginTop: "30px" }}
              >
                <div style={{ position: "relative" }}>
                  <div className="local-add-checkbox">
                    <label>Same as Local Address</label>
                    <input
                      type="checkbox"
                      checked={sameAsLocal}
                      onChange={handleCheckboxChange}
                      className="cr-custom-checkbox"
                      disabled={isReadOnly} // ← NEW
                    />
                  </div>
                  <FormInputs
                    label="Permanent Address"
                    type="text"
                    name="perm_add1"
                    value={address.perm_add1 || ""}
                    onChange={handleAddressChange}
                    placeholder="Address line 1"
                    disabled={sameAsLocal || isReadOnly} // ← NEW
                    maxlength="200"
                    pattern="[A-Za-z0-9-, ]{1,200}"
                    required
                    showError={showValidationErrors}
                  />
                  <FormInputs
                    type="text"
                    name="perm_add2"
                    value={address.perm_add2 || ""}
                    onChange={handleAddressChange}
                    placeholder="Address line 2"
                    maxlength="200"
                    pattern="[A-Za-z0-9-, ]{1,200}"
                    disabled={sameAsLocal || isReadOnly} // ← NEW
                  />
                </div>
                <div className="grid-container-address">
                  <div className="selecte-dropdown-items">
                    <SearchSelectedValues
                      initialOptions={permCityOptions}
                      selected={selectedPermCity}
                      onInputChange={fetchPermCityOptions}
                      onSelect={(option) => {
                        if (option) {
                          setSelectedPermCity(option);
                          setStateNamePerm(option.state_name);
                          setSelectedPermCityName(option.city_name);
                          setAddress((prev) => ({
                            ...prev,
                            perm_city_id: option.city_id,
                          }));
                        } else {
                          setSelectedPermCity(null);
                          setStateNamePerm("");
                          setAddress((prev) => ({
                            ...prev,
                            perm_city_id: 0,
                          }));
                        }
                      }}
                      placeholder="Search..."
                      label="City/District"
                      labelKey={(option) => option.city_name}
                      required={true}
                      showError={showValidationErrors}
                      disabled={sameAsLocal || isReadOnly} // ← NEW
                      initialValue={selectedPermCityName}
                    />
                  </div>
                  <div className="grid-item">
                    <FormInputs
                      label="State"
                      type="text"
                      value={stateNamePerm}
                      disabled={
                        selectedPermCity !== null || sameAsLocal || isReadOnly
                      } // ← NEW
                      required
                      showError={showValidationErrors}
                    />
                  </div>
                  <div className="grid-item">
                    <FormInputs
                      label="Pin Code"
                      type="text"
                      name="perm_pincode"
                      value={address.perm_pincode || ""}
                      onChange={handleAddressChange}
                      maxLength={6}
                      pattern="[0-9]{6}"
                      disabled={sameAsLocal || isReadOnly} // ← NEW
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* ══════════════════════════════════════════════════════════════════════
          GUARDIAN INFORMATION
      ══════════════════════════════════════════════════════════════════════ */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>GUARDIAN INFORMATION</label>
          </div>
          <div className="accordion-btn" onClick={toggleGuardianAccordion}>
            {isGuardianOpen ? (
              <div className="minus" />
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isGuardianOpen && (
          <div className="accordion-content">
            <div className="grid-container">
              <div className="grid-item">
                <FormInputs
                  label="Father's Name"
                  type="text"
                  name="fathers_name"
                  value={gaurdianInfo.fathers_name}
                  onChange={handleGuardianChange}
                  maxlength={200}
                  pattern="[A-Za-z ]{1,150}"
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Occupation"
                  type="text"
                  name="fathers_occupation"
                  value={gaurdianInfo.fathers_occupation}
                  onChange={handleGuardianChange}
                  maxlength={15}
                  pattern="[A-Za-z ]{1,50}"
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Designation"
                  type="text"
                  name="fathers_designation"
                  value={gaurdianInfo.fathers_designation}
                  onChange={handleGuardianChange}
                  maxlength={15}
                  pattern="[A-Za-z ]{1,50}"
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-item">
                <div className="selecte-dropdown-items">
                  <SelectDropdown
                    label="Annual Income"
                    selected={gaurdianInfo.fathers_annual_income}
                    setSelected={(selectedOption) => {
                      const incomeOption = [
                        { label: "0 To Rs 2,00,000", id: "1" },
                        { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
                        { label: "Rs 400000 To Rs 6,00,000", id: "3" },
                        { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
                        { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
                        { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
                        { label: "> Rs 15,00,000", id: "7" },
                        { label: "Not Available", id: "8" },
                      ].find((income) => income.id === selectedOption);

                      setSelectedFatherIncomeName(incomeOption?.label || "");
                      handleGuardianDropdownChange(
                        "fathers_annual_income",
                        selectedOption
                      );
                    }}
                    options={[
                      { label: "0 To Rs 2,00,000", id: "1" },
                      { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
                      { label: "Rs 400000 To Rs 6,00,000", id: "3" },
                      { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
                      { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
                      { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
                      { label: "> Rs 15,00,000", id: "7" },
                      { label: "Not Available", id: "8" },
                    ]}
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Email ID"
                  type="email"
                  name="fathers_email_id"
                  value={gaurdianInfo.fathers_email_id}
                  onChange={handleGuardianChange}
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Mobile Number"
                  type="text"
                  name="fathers_mob_no"
                  value={gaurdianInfo.fathers_mob_no}
                  onChange={handleGuardianChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-item" style={{ marginTop: "40px" }}>
                <FormInputs
                  label="Mother's Name"
                  type="text"
                  name="mothers_name"
                  value={gaurdianInfo.mothers_name}
                  onChange={handleGuardianChange}
                  maxlength={200}
                  pattern="[A-Za-z ]{1,50}"
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-item" style={{ marginTop: "40px" }}>
                <FormInputs
                  label="Occupation"
                  type="text"
                  name="mothers_occupation"
                  value={gaurdianInfo.mothers_occupation}
                  onChange={handleGuardianChange}
                  maxlength={15}
                  pattern="[A-Za-z ]{1,50}"
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-item" style={{ marginTop: "40px" }}>
                <FormInputs
                  label="Designation"
                  type="text"
                  name="mothers_designation"
                  value={gaurdianInfo.mothers_designation}
                  onChange={handleGuardianChange}
                  maxlength={15}
                  pattern="[A-Za-z ]{1,50}"
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-item">
                <div className="selecte-dropdown-items">
                  <SelectDropdown
                    label="Annual Income"
                    selected={gaurdianInfo.mothers_annual_income}
                    setSelected={(selectedOption) => {
                      const incomeOption = [
                        { label: "0 To Rs 2,00,000", id: "1" },
                        { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
                        { label: "Rs 400000 To Rs 6,00,000", id: "3" },
                        { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
                        { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
                        { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
                        { label: "> Rs 15,00,000", id: "7" },
                        { label: "Not Available", id: "8" },
                      ].find((income) => income.id === selectedOption);

                      setSelectedIncomeName(incomeOption?.label || "");
                      handleGuardianDropdownChange(
                        "mothers_annual_income",
                        selectedOption
                      );
                    }}
                    options={[
                      { label: "0 To Rs 2,00,000", id: "1" },
                      { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
                      { label: "Rs 400000 To Rs 6,00,000", id: "3" },
                      { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
                      { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
                      { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
                      { label: "> Rs 15,00,000", id: "7" },
                      { label: "Not Available", id: "8" },
                    ]}
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Email ID"
                  type="email"
                  name="mothers_email_id"
                  value={gaurdianInfo.mothers_email_id}
                  onChange={handleGuardianChange}
                  maxlength={150}
                  pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Mobile Number"
                  type="text"
                  name="mothers_mob_no"
                  value={gaurdianInfo.mothers_mob_no}
                  onChange={handleGuardianChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Guardian Name"
                  type="text"
                  name="guardian_name"
                  value={gaurdianInfo.guardian_name}
                  onChange={handleGuardianChange}
                  maxlength={200}
                  pattern="[A-Za-z, ]{1,50}"
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Guardian's Mobile Number"
                  type="text"
                  name="guardian_mob_no"
                  value={gaurdianInfo.guardian_mob_no}
                  onChange={handleGuardianChange}
                  pattern="[0-9]{10,11}"
                  maxLength={10}
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="grid-item">
                <FormInputs
                  label="Guardian's Relation"
                  type="text"
                  name="guardian_relation"
                  value={gaurdianInfo.guardian_relation || ""}
                  onChange={handleGuardianChange}
                  pattern="[0-9]{0,4}"
                  maxLength={4}
                  disabled={isReadOnly} // ← NEW
                />
              </div>
              <div className="comments">
                <label>Comments</label>
                <textarea
                  name="comments_"
                  value={gaurdianInfo.comments_}
                  style={{ color: "#6A6A6A", fontSize: "14px" }}
                  onChange={handleGuardianChange}
                  placeholder="Write your comment here..."
                  maxLength={500}
                  disabled={isReadOnly} // ← NEW
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* ══════════════════════════════════════════════════════════════════════
          CUSTOM FIELDS
      ══════════════════════════════════════════════════════════════════════ */}
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>CUSTOM FIELDS</label>
          </div>
          <div className="accordion-btn" onClick={toggleCustomAccordion}>
            {isCustomOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isCustomOpen && (
          <div className="accordion-content">
            <div className="grid-container">
              {[1, 2, 3, 4, 5, 6].map((n) => (
                <div className="grid-item" key={n}>
                  <FormInputs
                    label={`Custom Field ${n}`}
                    type="text"
                    name={`custom_field_${n}`}
                    value={customFields[`custom_field_${n}`]}
                    onChange={onCustomFieldChange}
                    disabled={isReadOnly} // ← NEW
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <PreviewModal
        isOpen={showPreviewModal}
        onClose={() => setShowPreviewModal(false)}
        data={{
          personalInfo,
          educationDetails,
          address,
          gaurdianInfo,
          customFields,
          imagePreview: image,
          courseName: selectedCourseName,
          genderName: selectedGenderName,
          categoryName: selectedCategoryName,
          subCategoryName: selectedSubCategoryName,
          coachingName: selectedCoachingName,
          className: selectedClassName,
          mediumName: selectedMediumName,
          selectedIncomeName: selectedIncomeName,
          selectedFatherIncomeName: selectedFatherIncomeName,
          localCityName: selectedLocalCityName,
          permCityName: selectedPermCityName,
          previousCoachingName: selectedPreviousCoachingName,
          domicileName:
            statedata?.find((s) => s.state_id === personalInfo.domicile_city_id)
              ?.state_name || "",
        }}
        onConfirm={handleConfirmSubmit}
      />
    </div>
  );
}

export default StudentRegEdit;

// import React, { useState, useEffect, useRef } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useLocation } from "react-router-dom";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import UploadImgIcon from "../../../Assets/Images/EployeeRegistration/icon-image.png";
// import PreviewModal from "../PreviewModel";
// import CropperModal from "../Cropper";
// import SearchDropdown from "../../OTC/dropdownInput";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import { fetchGenderData } from "../../../Redux/EmployeeRegistration/genderSlice";
// import { fetchCategorynData } from "../../../Redux/EmployeeRegistration/categorySlice";
// import { fetchSubCategorynData } from "../../../Redux/StudentRegistration/subcategorySlice";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { fetchCoachingData } from "../../../Redux/StudentRegistration/coachingSlice";
// import { fetchStateData } from "../../../Redux/StudentRegistration/stateSlice";
// import { fetchClassTypeData } from "../../../Redux/StudentRegistration/classTypeSlice";
// import { fetchSchoolNameData } from "../../../Redux/StudentRegistration/schoolSlice";
// import { fetchClassData } from "../../../Redux/StudentRegistration/classSlice";
// import { fetchMediumData } from "../../../Redux/StudentRegistration/mediumSlice";
// import { fetchBoardData } from "../../../Redux/StudentRegistration/boardSlice";
// import SchoolSearch from "../SchoolSearch";
// import EndPoints from "../../../Api/EndPoints";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import WarningIcon from "../../../Assets/Images/CommanImages/Warning.png";
// import SelectDropdown from "../../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
// import studentDummyData from "./studentDummyData.json";
// import SearchSelectedValues from "./SearchSelectedValues";
// import SearchSelectedSchool from "./SearchSelectedSchool";

// function StudentRegEdit({
//   dataClient,
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setMessageBoxHeight,
//   setActiveImg,
//   setNoTimeSet,
// }) {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);
//   const studentIdFromUrl = searchParams.get('studentId');
//   const { statedata, loading, error } = useSelector((state) => state.domstate);
//   const { subcategorydata } = useSelector((state) => state.subcategoies);
//   const { genderdata } = useSelector((state) => state.gender);
//   const { categorydata } = useSelector((state) => state.categories);
//   const { coursesdata } = useSelector((state) => state.course);
//   const { coachingData } = useSelector((state) => state.coaching);
//   const { classtypedata } = useSelector((state) => state.classType);
//   const { schoolnamedata } = useSelector((state) => state.schoolname);
//   const { classData } = useSelector((state) => state.classname);
//   const { mediumData } = useSelector((state) => state.medium);
//   const { boardData } = useSelector((state) => state.board);
//   const [customFields, setCustomFields] = useState({
//     custom_field_1: "",
//     custom_field_2: "",
//     custom_field_3: "",
//     custom_field_4: "",
//     custom_field_5: "",
//     custom_field_6: "",
//   });
//   const [isCustomOpen, setIsCustomOpen] = useState(false);
//   const [showPreviewModal, setShowPreviewModal] = useState(false);
//   const [showValidationErrors, setShowValidationErrors] = useState(false);
//   const [selectedCourseName, setSelectedCourseName] = useState("");
//   const [selectedGenderName, setSelectedGenderName] = useState("");
//   const [selectedCategoryName, setSelectedCategoryName] = useState("");
//   const [selectedSubCategoryName, setSelectedSubCategoryName] = useState("");
//   const [selectedCoachingName, setSelectedCoachingName] = useState("");
//   const [selectedClassName, setSelectedClassName] = useState("");
//   const [selectedMediumName, setSelectedMediumName] = useState("");
//   const [selectedIncomeName, setSelectedIncomeName] = useState("");
//   const [selectedFatherIncomeName, setSelectedFatherIncomeName] = useState("");
//   const [selectedLocalCityName, setSelectedLocalCityName] = useState("");
//   const [selectedPermCityName, setSelectedPermCityName] = useState("");
//   const [selectedPreviousCoachingName, setSelectedPreviousCoachingName] = useState("");
//   const [rollNumberErrors, setRollNumberErrors] = useState([]);
//   const [address, setAddress] = useState({});
//   const [educationDetails, setEducationDetails] = useState({});
//   const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
//   const [isEduOpen, setIsEduOpen] = useState(false);
//   const [selectedSchoolName, setSelectedSchoolName] = useState('');
//   const [isAddressOpen, setIsAddressOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredCity, setFilteredCity] = useState([]);
//   const [activeIndex, setActiveIndex] = useState(-1);
//   const searchContainerRef = useRef(null);
//   const [searchPermCity, setSearchPermCity] = useState("");
//   const [filteredPermCity, setFilteredPermCity] = useState([]);
//   const searchPermCityRef = useRef(null);
//   const [sameAsLocal, setSameAsLocal] = useState(false);
//   const [localCityOptions, setLocalCityOptions] = useState([]);
//   const [selectedCity, setSelectedCity] = useState(null);
//   const [stateName, setStateName] = useState("");
//   const [permCityOptions, setPermCityOptions] = useState([]);
//   const [selectedPermCity, setSelectedPermCity] = useState(null);
//   const [stateNamePerm, setStateNamePerm] = useState("");
//   const [isGuardianOpen, setIsGuardianOpen] = useState(false);
//   const [gaurdianInfo, setGaurdianInfo] = useState({
//     fathers_name: "",
//     fathers_occupation: "",
//     fathers_designation: "",
//     fathers_annual_income: "",
//     fathers_email_id: "",
//     fathers_mob_no: "",
//     mothers_name: "",
//     mothers_occupation: "",
//     mothers_designation: "",
//     mothers_annual_income: "",
//     mothers_email_id: "",
//     mothers_mob_no: "",
//     guardian_name: "",
//     guardian_mob_no: "",
//     guardian_relation: null,
//     comments_: "",
//   });
//   const [personalInfo, setPersonalInfo] = useState({
//     enquiry_id: null,
//     roll_number: "",
//     class_type_id: null,
//     student_first_name: "",
//     student_middle_name: "",
//     student_last_name: "",
//     date_of_birth: "",
//     gender_id: 0,
//     aadhaar_no: "",
//     category_id: null,
//     sub_category_id: null,
//     domicile_city_id: 0,
//     student_mob_no: "",
//     email_id: "",
//     emrgency_contact_mob_no: "",
//     course_id: null,
//     last_coaching_id: null,
//     delete_flag: 0,
//     photograph: "",
//   });
//   const [croppedImageBlob, setCroppedImageBlob] = useState(null);
//   const [image, setImage] = useState(null);
//   const [showCropper, setShowCropper] = useState(false);
//   const [fileName, setFileName] = useState("No selected file");
//   const [src, setSrc] = useState(null);
//   const cropperRef = useRef(null);
//   const [isOpen, setIsOpen] = useState(true);
//   const [rollNumberMessage, setRollNumberMessage] = useState("");
//   const client_id = dataClient?.client_schema_name[6][0].client_id;
//   const user_name = dataClient?.client_schema_name[6][0].user_name;
//   const client_branch_id = dataClient?.client_schema_name[6][0].client_branch_id;
//   const accessToken = localStorage.getItem("other");
//   const [isEditMode, setIsEditMode] = useState(false);

//   const fetchStudentDataByStudentId = async (studentId) => {
//     try {
//       const accessToken = localStorage.getItem("other");
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-student-reg-details/?student_id=${studentId}`,
//         {
//           headers: {
//             accept: "application/json",
//             Authorization: `Bearer ${accessToken}`,
//           },
//         }
//       );
//       if (!response.ok) {
//         throw new Error("Failed to fetch student data");
//       }
//       const data = await response.json();
//       await populateFormData(data);  // Add await here
//     } catch (error) {
//       console.error("Error fetching student data:", error);
//       showErrorMessage(["Failed to load student data. Please try again."]);
//     }
//   };

//   const populateFormData = async (data) => {
//   setPersonalInfo({
//     enquiry_id: data.enquiry_id || null,
//     roll_number: data.roll_number || "",
//     class_type_id: data.class_type_id || null,
//     student_first_name: data.student_first_name || "",
//     student_middle_name: data.student_middle_name || "",
//     student_last_name: data.student_last_name || "",
//     date_of_birth: data.date_of_birth || "",
//     gender_id: data.gender_id || 0,
//     aadhaar_no: data.aadhaar_no || "",
//     category_id: data.category_id || null,
//     sub_category_id: data.sub_category_id || null,
//     domicile_city_id: data.domicile_city_id || 0,
//     student_mob_no: data.student_mob_no || "",
//     email_id: data.email_id || "",
//     emrgency_contact_mob_no: data.emrgency_contact_mob_no || "",
//     course_id: data.course_id || null,
//     last_coaching_id: data.last_coaching_id || null,
//     delete_flag: 0,
//     photograph: data.photograph || "",
//   });

//   setEducationDetails({
//     last_school_id: data.last_school_id || null,
//     current_class_id: data.current_class_id || null,
//     education_medium_id: data.education_medium_id || null,
//     board_id_5: data.board_id_5 || null,
//     pass_year_5: data.pass_year_5 || "",
//     school_name_5: data.school_name_5 || "",
//     percentage_cgpa_5: data.percentage_cgpa_5 || "",
//     board_id_6: data.board_id_6 || null,
//     pass_year_6: data.pass_year_6 || "",
//     school_name_6: data.school_name_6 || "",
//     percentage_cgpa_6: data.percentage_cgpa_6 || "",
//     board_id_7: data.board_id_7 || null,
//     pass_year_7: data.pass_year_7 || "",
//     school_name_7: data.school_name_7 || "",
//     percentage_cgpa_7: data.percentage_cgpa_7 || "",
//     board_id_8: data.board_id_8 || null,
//     pass_year_8: data.pass_year_8 || "",
//     school_name_8: data.school_name_8 || "",
//     percentage_cgpa_8: data.percentage_cgpa_8 || "",
//     board_id_9: data.board_id_9 || null,
//     pass_year_9: data.pass_year_9 || "",
//     school_name_9: data.school_name_9 || "",
//     percentage_cgpa_9: data.percentage_cgpa_9 || "",
//     board_id_10: data.board_id_10 || null,
//     pass_year_10: data.pass_year_10 || "",
//     school_name_10: data.school_name_10 || "",
//     percentage_cgpa_10: data.percentage_cgpa_10 || "",
//     board_id_11: data.board_id_11 || null,
//     pass_year_11: data.pass_year_11 || "",
//     school_name_11: data.school_name_11 || "",
//     percentage_cgpa_11: data.percentage_cgpa_11 || "",
//     board_id_12: data.board_id_12 || null,
//     pass_year_12: data.pass_year_12 || "",
//     school_name_12: data.school_name_12 || "",
//     percentage_cgpa_12: data.percentage_cgpa_12 || "",
//   });

//   setAddress({
//     loc_add1: data.loc_add1 || "",
//     loc_add2: data.loc_add2 || "",
//     loc_city_id: data.loc_city_id || null,
//     loc_pincode: data.loc_pincode || "",
//     perm_add1: data.perm_add1 || "",
//     perm_add2: data.perm_add2 || "",
//     perm_city_id: data.perm_city_id || null,
//     perm_pincode: data.perm_pincode || "",
//   });

//   setGaurdianInfo({
//     fathers_name: data.fathers_name || "",
//     fathers_occupation: data.fathers_occupation || "",
//     fathers_designation: data.fathers_designation || "",
//     fathers_annual_income: data.fathers_annual_income || "",
//     fathers_email_id: data.fathers_email_id || "",
//     fathers_mob_no: data.fathers_mob_no || "",
//     mothers_name: data.mothers_name || "",
//     mothers_occupation: data.mothers_occupation || "",
//     mothers_designation: data.mothers_designation || "",
//     mothers_annual_income: data.mothers_annual_income || "",
//     mothers_email_id: data.mothers_email_id || "",
//     mothers_mob_no: data.mothers_mob_no || "",
//     guardian_name: data.guardian_name || "",
//     guardian_mob_no: data.guardian_mob_no || "",
//     guardian_relation: data.guardian_relation || null,
//     comments_: data.comments_ || "",
//   });

//   setCustomFields({
//     custom_field_1: data.custom_field_1 || "",
//     custom_field_2: data.custom_field_2 || "",
//     custom_field_3: data.custom_field_3 || "",
//     custom_field_4: data.custom_field_4 || "",
//     custom_field_5: data.custom_field_5 || "",
//     custom_field_6: data.custom_field_6 || "",
//   });

//   // Set dropdown selections
//   if (data.course_id && coursesdata) {
//     const course = coursesdata.find((c) => c.course_id === data.course_id);
//     setSelectedCourseName(course?.course_description || "");
//   }
//   if (data.gender_id && genderdata) {
//     const gender = genderdata.find((g) => g.gender_id === data.gender_id);
//     setSelectedGenderName(gender?.gender_name || "");
//   }
//   if (data.category_id && categorydata) {
//     const category = categorydata.find((c) => c.category_id === data.category_id);
//     setSelectedCategoryName(category?.category_desc || "");
//   }
//   if (data.sub_category_id && subcategorydata) {
//     const subCategory = subcategorydata.find((s) => s.sub_category_id === data.sub_category_id);
//     setSelectedSubCategoryName(subCategory?.sub_category_desc || "");
//   }
//   if (data.last_coaching_id && coachingData) {
//     const coaching = coachingData.find((c) => c.institute_id === data.last_coaching_id);
//     setSelectedCoachingName(coaching?.institute_name || "");
//     setSelectedPreviousCoachingName(coaching?.institute_name || "");
//   }
//   if (data.current_class_id && classData) {
//     const classItem = classData.find((cls) => cls.class_id === data.current_class_id);
//     setSelectedClassName(classItem?.class_name || "");
//   }
//   if (data.education_medium_id && mediumData) {
//     const medium = mediumData.find((med) => med.medium_id === data.education_medium_id);
//     setSelectedMediumName(medium?.medium_desc || "");
//   }

//   // **FIX: Fetch city details with state_name for LOCAL city**
//   if (data.loc_city_id) {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${data.city_name}`,
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );
//       const cities = await response.json();
//       const city = cities.find((c) => c.city_id === data.loc_city_id);

//       if (city) {
//         setSelectedLocalCityName(city.city_name);
//         setSearchTerm(city.city_name);
//         setStateName(city.state_name || "");
//         setSelectedCity(city);
//       } else {
//         // Fallback if city not found
//         setSelectedLocalCityName(data.city_name || "");
//         setSearchTerm(data.city_name || "");
//         setSelectedCity({ city_id: data.loc_city_id, city_name: data.city_name || "" });
//       }
//     } catch (error) {
//       console.error("Error fetching local city details:", error);
//       setSelectedLocalCityName(data.city_name || "");
//       setSearchTerm(data.city_name || "");
//       setSelectedCity({ city_id: data.loc_city_id, city_name: data.city_name || "" });
//     }
//   }

//   // **FIX: Fetch city details with state_name for PERMANENT city**
//   if (data.perm_city_id) {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${data.city_name}`,
//         { headers: { Authorization: `Bearer ${accessToken}` } }
//       );
//       const cities = await response.json();
//       const city = cities.find((c) => c.city_id === data.perm_city_id);

//       if (city) {
//         setSelectedPermCityName(city.city_name);
//         setSearchPermCity(city.city_name);
//         setStateNamePerm(city.state_name || "");
//         setSelectedPermCity(city);
//       } else {
//         // Fallback if city not found
//         setSelectedPermCityName(data.city_name || "");
//         setSearchPermCity(data.city_name || "");
//         setSelectedPermCity({ city_id: data.perm_city_id, city_name: data.city_name || "" });
//       }
//     } catch (error) {
//       console.error("Error fetching permanent city details:", error);
//       setSelectedPermCityName(data.city_name || "");
//       setSearchPermCity(data.city_name || "");
//       setSelectedPermCity({ city_id: data.perm_city_id, city_name: data.city_name || "" });
//     }
//   }

//   if (data.school_name) {
//     setSelectedSchoolName(data.school_name);
//   }

//   if (data.photograph) {
//     setImage(data.photograph);
//     setFileName("student_photo.jpg");
//   }

//   const incomeOptions = [
//     { label: "0 To Rs 2,00,000", id: "1" },
//     { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
//     { label: "Rs 400000 To Rs 6,00,000", id: "3" },
//     { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
//     { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
//     { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
//     { label: "> Rs 15,00,000", id: "7" },
//     { label: "Not Available", id: "8" },
//   ];
//   if (data.fathers_annual_income) {
//     const fatherIncome = incomeOptions.find((opt) => opt.id === data.fathers_annual_income);
//     setSelectedFatherIncomeName(fatherIncome?.label || "");
//   }
//   if (data.mothers_annual_income) {
//     const motherIncome = incomeOptions.find((opt) => opt.id === data.mothers_annual_income);
//     setSelectedIncomeName(motherIncome?.label || "");
//   }
// };

//   useEffect(() => {
//     if (studentIdFromUrl) {
//       if (
//         (genderdata?.length > 0) &&
//         (categorydata?.length > 0) &&
//         (subcategorydata?.length > 0) &&
//         (coursesdata?.length > 0) &&
//         (coachingData?.length > 0) &&
//         (classData?.length > 0) &&
//         (mediumData?.length > 0) &&
//         (boardData?.length > 0)
//       ) {
//         fetchStudentDataByStudentId(studentIdFromUrl);
//       }
//     }
//   }, [studentIdFromUrl, genderdata, categorydata, subcategorydata, coursesdata, coachingData, classData, mediumData, boardData]);

//   useEffect(() => {
//     dispatch(fetchGenderData());
//     dispatch(fetchCategorynData());
//     dispatch(fetchSubCategorynData());
//     dispatch(fetchCourseData());
//     dispatch(fetchCoachingData());
//     dispatch(fetchStateData());
//     dispatch(fetchClassTypeData());
//     dispatch(fetchSchoolNameData());
//     dispatch(fetchClassData());
//     dispatch(fetchMediumData());
//     dispatch(fetchBoardData());
//   }, [dispatch]);

//   useEffect(() => {
//     const hasChanges =
//       personalInfo.roll_number !== "" ||
//       personalInfo.student_first_name !== "" ||
//       personalInfo.student_mob_no !== "" ||
//       Object.keys(address).length > 0 ||
//       Object.keys(educationDetails).length > 0 ||
//       Object.keys(gaurdianInfo).length > 0 ||
//       croppedImageBlob !== null;
//     Object.values(customFields).some(val => val !== "");

//     setHasUnsavedChanges(hasChanges);
//   }, [personalInfo, address, educationDetails, gaurdianInfo, croppedImageBlob, customFields]);

//   useEffect(() => {
//     if (croppedImageBlob) {
//       setPersonalInfo((prev) => ({
//         ...prev,
//         IMG: croppedImageBlob,
//       }));
//       console.log("Sending image:", {
//         imageSize: croppedImageBlob.size,
//         imageType: croppedImageBlob.type,
//         imageName: croppedImageBlob.name,
//       });
//     }
//   }, [croppedImageBlob]);

//   const onChange = (event) => {
//     const { name, value } = event.target;
//     setPersonalInfo((prev) => ({
//       ...prev,
//       [name]: value,
//     }));

//     if (name === "roll_number") {
//       const inputElement = event.target;

//       const handleBlur = () => {
//         if (!value.trim()) return;

//         fetch(
//           `${FULL_API_BASE_URL}/check_roll_no/?roll_no=${value.trim()}`
//         )
//           .then((response) => response.json())
//           .then((data) => {
//             if (data.status === 200) {
//               setMessageBox(
//                 <div className="Container-messageBOX">
//                   <div className="messagebox-insider1">
//                     <div className="loader-tc success"></div>
//                     <span>{data.message}</span>
//                   </div>
//                 </div>
//               );
//               setIsMessageBoxVisible(true);
//               setActiveImg(WarningIcon);
//             }
//           })
//           .catch((error) => {
//             console.error("Error checking roll number:", error);

//             setMessageBox(
//               <div className="Container-messageBOX">
//                 <div className="messagebox-insider1">
//                   <div className="loader-tc error"></div>
//                   <span>Error checking roll number. Please try again.</span>
//                 </div>
//               </div>
//             );
//             setIsMessageBoxVisible(true);
//             setActiveImg(WarningIcon);
//           })
//           .finally(() => {
//             inputElement.removeEventListener("blur", handleBlur);
//           });
//       };

//       inputElement.addEventListener("blur", handleBlur);
//     }
//   };

//   const handleRollNumberBlur = async (e) => {
//     const rollNumber = e.target.value.trim();
//     setRollNumberErrors([]);
//     if (!rollNumber) {
//         return;
//     }
//     try {
//         const result = await checkDuplicateRollNumber(rollNumber);
//         if (result.isDuplicate) {
//         const newErrors = [
//             "This roll number is already registered, please use a different roll number"
//         ];
//         setRollNumberErrors(newErrors);

//         showErrorMessage(newErrors);
//         } else {
//         setRollNumberErrors([]);
//         }
//     } catch (error) {
//         console.error("Validation error:", error);
//     }
//     };

//   const handleStateSelect = (selectedOption) => {
//     setPersonalInfo((prevValues) => ({
//       ...prevValues,
//       domicile_city_id: selectedOption ? selectedOption.state_id : null,
//     }));
//   };
//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFileName(file.name);
//       const reader = new FileReader();
//       reader.onload = () => {
//         setSrc(reader.result);
//         setImage(reader.result);
//         setShowCropper(true);
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handleCroppedImage = (croppedFile) => {
//     setCroppedImageBlob(croppedFile);
//     setImage(URL.createObjectURL(croppedFile));
//     setPersonalInfo((prev) => ({
//       ...prev,
//       photograph: croppedFile,
//       IMG: croppedFile,
//     }));
//     setShowCropper(false);
//     setSrc(null);
//   };

//   const handleDeleteImage = () => {
//     setImage(null);
//     setSrc(null);
//     setFileName("No selected file");
//     setCroppedImageBlob(null);
//     setPersonalInfo((prev) => ({
//       ...prev,
//       photograph: null,
//       IMG: null,
//     }));
//     setShowCropper(false);
//   };

//   const handleCropComplete = async () => {
//     if (!cropperRef.current) return;

//     try {
//       const dataUrl = cropperRef.current.getImage().toDataURL();
//       const result = await fetch(dataUrl);
//       const blob = await result.blob();

//       const timestamp = new Date().getTime();
//       const filename = `profile_${timestamp}.jpg`;

//       const file = new File([blob], filename, {
//         type: "image/jpeg",
//         lastModified: Date.now(),
//       });

//       handleCroppedImage(file);
//     } catch (err) {
//       console.error("Image processing error:", err);
//       showErrorMessage(["Error processing image. Please try again."]);
//     }
//   };

//   const showErrorMessage = (errors) => {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span style={{ whiteSpace: "pre-line" }}>
//             {errors.length === 1
//               ? errors[0]
//               : errors.join("\n")
//             }
//           </span>
//         </div>
//       </div>
//     );
//     setIsMessageBoxVisible(true);
//     setMessageBoxHeight("auto");
//     setActiveImg(ErrorImg);
//   };

//   const showSuccessMessage = (message) => {
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc success"></div>
//           <span>{message}</span>
//         </div>
//       </div>
//     );
//     setIsMessageBoxVisible(true);
//     setHasUnsavedChanges("10vh")
//     setActiveImg(InterogativeImg);
//   };

//   const checkDuplicateRollNumber = async (rollNumber) => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/check_roll_no/?roll_no=${rollNumber.trim()}`
//       );

//       const data = await response.json();
//       console.log("API Response:", data, "Status:", response.status);

//       if (data.status === 200) {
//         return {
//           isDuplicate: true,
//           message: data.message || "This roll number already exists"
//         };
//       }

//       return {
//         isDuplicate: false,
//         message: "Roll number is available"
//       };
//     } catch (error) {
//       console.error("Error checking roll number:", error);
//       return {
//         isDuplicate: false,
//         message: "Could not validate"
//       };
//     }
//   };

//   const validateFormWithErrors = async () => {
//     const errors = [];
//     if (!personalInfo.roll_number) {
//       errors.push("Student Roll Number is required");
//     } else {
//       // If roll number exists, check if it's duplicate
//       try {
//         const rollNumberCheck = await checkDuplicateRollNumber(personalInfo.roll_number);

//         if (rollNumberCheck.isDuplicate) {
//           errors.push( "This roll number is already registered, please use a different roll number");
//         }
//       } catch (error) {
//         console.error("Error checking roll number:", error);
//         errors.push("Error validating roll number. Please try again.");
//       }
//     }

//     if (!personalInfo.class_type_id) {
//       errors.push("Class Type is required");
//     }
//     if (!personalInfo.student_first_name) {
//       errors.push("First Name is required");
//     }
//     if (!personalInfo.date_of_birth) {
//       errors.push("Date of Birth is required");
//     }
//     if (!personalInfo.gender_id || personalInfo.gender_id === 0) {
//       errors.push("Gender is required");
//     }
//     if(!personalInfo.category_id){
//       errors.push("Category is required")
//     }
//     if(!personalInfo.sub_category_id){
//       errors.push("Sub Category is required")
//     }
//     if (!personalInfo.student_mob_no) {
//       errors.push("Mobile Number is required");
//     }
//     if (!personalInfo.emrgency_contact_mob_no) {
//       errors.push("Emergency Contact Number is required");
//     }
//     if (!personalInfo.course_id) {
//       errors.push("Course is required");
//     }
//     if (!educationDetails.current_class_id) {
//       errors.push("Current Class is required");
//     }
//     if (!educationDetails.education_medium_id) {
//       errors.push("Education Medium is required");
//     }
//     if (!address.loc_add1) {
//       errors.push("Local Address is required");
//     }
//     if (!address.loc_city_id) {
//       errors.push("Local City is required");
//     }
//     if (!address.perm_add1) {
//       errors.push("Permanent Address is required");
//     }
//     if (!address.perm_city_id) {
//       errors.push("Permanent City is required");
//     }

//     const hasFatherInfo = gaurdianInfo.fathers_name && gaurdianInfo.fathers_mob_no;
//     const hasMotherInfo = gaurdianInfo.mothers_name && gaurdianInfo.mothers_mob_no;

//     if (!hasFatherInfo && !hasMotherInfo) {
//       errors.push("Please provide either father's or mother's information");
//     }

//     return errors;
//   };

//   const clearFormData = () => {
//     setPersonalInfo({
//       enquiry_id: null,
//       roll_number: "",
//       class_type_id: null,
//       student_first_name: "",
//       student_middle_name: "",
//       student_last_name: "",
//       date_of_birth: "",
//       gender_id: 0,
//       aadhaar_no: "",
//       category_id: null,
//       sub_category_id: null,
//       domicile_city_id: 0,
//       student_mob_no: "",
//       email_id: "",
//       emrgency_contact_mob_no: "",
//       course_id: null,
//       last_coaching_id: null,
//       delete_flag: 0,
//       photograph: "",
//     });
//     setEducationDetails({});
//     setAddress({});
//     setGaurdianInfo({});
//     setCustomFields({
//       custom_field_1: "",
//       custom_field_2: "",
//       custom_field_3: "",
//       custom_field_4: "",
//       custom_field_5: "",
//       custom_field_6: "",
//     });
//     setImage(null);
//     setCroppedImageBlob(null);
//     setHasUnsavedChanges(false);
//   };

//   const handleSubmit = async () => {
//     const errors = await validateFormWithErrors();
//     if (errors.length > 0) {
//       setShowValidationErrors(true);
//       showErrorMessage(errors);
//       return;
//     }
//     setShowValidationErrors(false);
//     setShowPreviewModal(true);
//   };

//   useEffect(() => {
//     if (showValidationErrors) {
//       const errors = validateFormWithErrors();
//       if (errors.length === 0) {
//         setShowValidationErrors(false);
//       }
//     }
//   }, [personalInfo, address, educationDetails, gaurdianInfo, showValidationErrors]);

//  const handleConfirmSubmit = async () => {
//   try {
//     const formData = new FormData();
//     const studentData = {
//       ...personalInfo,
//       ...educationDetails,
//       ...address,
//       ...gaurdianInfo,
//       ...customFields,
//       enquiry_id: personalInfo.enquiry_id || null,
//       emergency_contact_name: "Not Available",
//       status: 1,
//       last_modified_date: new Date().toISOString(),
//       last_modified_by: user_name,
//       create_date: new Date().toISOString(),
//       created_by: user_name,
//       client_branch_id: client_branch_id,
//       client_id: client_id,
//       delete_flag: 0,

//       // Board/class fields
//       board_id_5: educationDetails.board_id_5 || null,
//       pass_year_5: educationDetails.pass_year_5 || "",
//       school_name_5: educationDetails.school_name_5 || "",
//       percentage_cgpa_5: educationDetails.percentage_cgpa_5 || "",

//       board_id_6: educationDetails.board_id_6 || null,
//       pass_year_6: educationDetails.pass_year_6 || "",
//       school_name_6: educationDetails.school_name_6 || "",
//       percentage_cgpa_6: educationDetails.percentage_cgpa_6 || "",

//       board_id_7: educationDetails.board_id_7 || null,
//       pass_year_7: educationDetails.pass_year_7 || "",
//       school_name_7: educationDetails.school_name_7 || "",
//       percentage_cgpa_7: educationDetails.percentage_cgpa_7 || "",

//       board_id_8: educationDetails.board_id_8 || null,
//       pass_year_8: educationDetails.pass_year_8 || "",
//       school_name_8: educationDetails.school_name_8 || "",
//       percentage_cgpa_8: educationDetails.percentage_cgpa_8 || "",

//       board_id_9: educationDetails.board_id_9 || null,
//       pass_year_9: educationDetails.pass_year_9 || "",
//       school_name_9: educationDetails.school_name_9 || "",
//       percentage_cgpa_9: educationDetails.percentage_cgpa_9 || "",

//       board_id_10: educationDetails.board_id_10 || null,
//       pass_year_10: educationDetails.pass_year_10 || "",
//       school_name_10: educationDetails.school_name_10 || "",
//       percentage_cgpa_10: educationDetails.percentage_cgpa_10 || "",

//       board_id_11: educationDetails.board_id_11 || null,
//       pass_year_11: educationDetails.pass_year_11 || "",
//       school_name_11: educationDetails.school_name_11 || "",
//       percentage_cgpa_11: educationDetails.percentage_cgpa_11 || "",

//       board_id_12: educationDetails.board_id_12 || null,
//       pass_year_12: educationDetails.pass_year_12 || "",
//       school_name_12: educationDetails.school_name_12 || "",
//       percentage_cgpa_12: educationDetails.percentage_cgpa_12 || "",

//       guardian_name: gaurdianInfo.guardian_name || "",
//       guardian_mob_no: gaurdianInfo.guardian_mob_no || "",
//       guardian_relation: gaurdianInfo.guardian_relation || null,
//       comments_: gaurdianInfo.comments_ || ""
//     };

//     // Handle image
//     if (personalInfo.IMG) {
//       const photograph = personalInfo.IMG;
//       const { IMG, ...dataWithoutImage } = studentData;
//       formData.append('photograph', photograph);
//       formData.append('student_data', JSON.stringify(dataWithoutImage));
//     } else {
//       formData.append('student_data', JSON.stringify(studentData));
//     }

//     // Make API call
//     const response = await fetch(
//       `${EndPoints.NEW_STUDENT_REGISTRATION}`,
//       {
//         method: 'POST',
//         body: formData
//       }
//     );

//     if (!response.ok) {
//       const errorData = await response.json();
//       throw new Error(errorData.detail || errorData.message || "Failed to submit form");
//     }

//     const responseData = await response.json();

//     // Close modal FIRST
//     setShowPreviewModal(false);

//     // Then show success/error
//     if (responseData.result === "success") {
//       showSuccessMessage(responseData.message || "Student registered successfully");
//       clearFormData();
//       setTimeout(() => {
//         window.location.reload();
//       }, 2000);
//     } else {
//       showErrorMessage([responseData.message || "Registration failed"]);
//     }

//   } catch (error) {
//     console.error('Form submission error:', error);
//     setShowPreviewModal(false);
//     showErrorMessage([error.message || "Error submitting form"]);
//   }
// };

//   const onCustomFieldChange = (e) => {
//     const { name, value } = e.target;
//     setCustomFields({ ...customFields, [name]: value });
//   };

//   const toggleCustomAccordion = () => {
//     setIsCustomOpen(!isCustomOpen);
//   };

//   const handleCancel = () => {
//     if (hasUnsavedChanges) {
//       if (setMessageBox && setIsMessageBoxVisible) {
//         if (setMessageBoxHeight) {
//           setMessageBoxHeight("10vh");
//         }

//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>
//                 You have unsaved changes. Do you want to continue?
//               </span>
//             </div>
//             <div
//               className="messagebox-insider2"
//               style={{ display: "flex", gap: "10px", marginTop: "10px" }}
//             >
//               <button
//                 className="messagebox-cancel-btn-ok"
//                 onClick={() => {
//                   clearFormData();
//                   setIsMessageBoxVisible(false);
//                   navigate("/studentdashboard"); // 👈 replace with your actual route path
//                 }}
//               >
//                 YES
//               </button>
//               <button
//                 className="messagebox-cancel-btn-ok"
//                 onClick={() => {
//                   setIsMessageBoxVisible(false);
//                 }}
//               >
//                 NO
//               </button>
//             </div>
//           </div>
//         );
//         setIsMessageBoxVisible(true);
//         setActiveImg(WarningIcon)
//       }
//     } else {
//       // window.location.reload();
//       navigate("/studentdashboard");
//     }
//   };

//   // CHANGE this in StudentRegEdit
//   const handleSchoolSelect = (school) => {
//     if (!school) {
//       // handle clear
//       setEducationDetails((prevInfo) => ({
//         ...prevInfo,
//         last_school_id: null,
//       }));
//       setSelectedSchoolName("");
//       return;
//     }
//     setEducationDetails((prevInfo) => ({
//       ...prevInfo,
//       last_school_id: school.school_id,
//     }));
//     setSelectedSchoolName(school.school_name);
//   };

//   const handleEducationChange = (e) => {
//     const { name, value } = e.target;
//     setEducationDetails((prevInfo) => ({ ...prevInfo, [name]: value }));
//   };

//   const toggleEducationAccordion = () => {
//     setIsEduOpen(!isEduOpen);
//   };

//   const toggleAccordion = () => {
//     setIsOpen(!isOpen);
//   };

//   const handleAddressChange = (e) => {
//     const { name, value } = e.target;
//     setAddress((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleCheckboxChange = (event) => {
//     setSameAsLocal(event.target.checked);
//     if (event.target.checked) {
//       setAddress((prev) => ({
//         ...prev,
//         perm_add1: prev.loc_add1,
//         perm_add2: prev.loc_add2,
//         perm_pincode: prev.loc_pincode,
//         perm_city_id: prev.loc_city_id,
//       }));
//       setSearchPermCity(searchTerm);
//       setStateNamePerm(stateName);
//       setSelectedPermCity(selectedCity);
//     } else {
//       setAddress((prev) => ({
//         ...prev,
//         perm_add1: "",
//         perm_add2: "",
//         perm_pincode: "",
//         perm_city_id: "",
//       }));
//       setSearchPermCity("");
//       setStateNamePerm("");
//       setSelectedPermCity(null);
//     }
//   };

//   const handleItemClickOne = (item) => {
//     setSelectedCity(item);
//     setSearchTerm(item.city_name);
//     setStateName(item.state_name);
//     setFilteredCity([]);
//     setActiveIndex(-1);
//     setAddress((prev) => ({
//       ...prev,
//       loc_city_id: item.city_id,
//     }));
//   };

//   const toggleAddressAccordion = () => {
//     setIsAddressOpen(!isAddressOpen);
//   };

//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     setActiveIndex(-1);
//     if (value.trim() === "") {
//       setFilteredCity([]);
//       setSelectedCity(null);
//       setStateName("");
//     } else if (value.length >= 2) {
//       handleSearchClick();
//     }
//   };

//   const handleSearchClick = () => {
//     if (searchTerm.trim() === "" || searchTerm.length < 2) {
//       setFilteredCity([]);
//       return;
//     }
//     setSearchTerm((prevSearchTerm) => {
//       fetch(
//         `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${encodeURIComponent(
//           prevSearchTerm
//         )}`
//       )
//         .then((response) => {
//           if (!response.ok) {
//             throw new Error("Network response was not ok");
//           }
//           return response.json();
//         })
//         .then((data) => {
//           const filtered = data.filter((item) =>
//             Object.values(item).some(
//               (val) =>
//                 typeof val === "string" &&
//                 val.toLowerCase().includes(prevSearchTerm.toLowerCase())
//             )
//           );
//           setFilteredCity(filtered);
//           setActiveIndex(filtered.length > 0 ? 0 : -1);
//         })
//         .catch((error) => {
//           console.error("Error fetching city list:", error);
//         });
//       return prevSearchTerm;
//     });
//   };

//   const handleClickOutside = (event) => {
//     if (
//       searchContainerRef.current &&
//       !searchContainerRef.current.contains(event.target)
//     ) {
//       setFilteredCity([]);
//     }
//   };

//   const fetchLocalCityOptions = (inputText) => {
//     if (inputText.trim().length < 2) {
//       setLocalCityOptions([]);
//       return;
//     }
//     fetch(
//       `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${encodeURIComponent(
//         inputText
//       )}`
//     )
//       .then((response) => {
//         if (!response.ok) throw new Error("Network response was not ok");
//         return response.json();
//       })
//       .then((data) => {
//         setLocalCityOptions(data);
//       })
//       .catch((error) => {
//         console.error("Error fetching local city list:", error);
//       });
//   };

//   const fetchPermCityOptions = (inputText) => {
//     if (inputText.trim().length < 2) {
//       setPermCityOptions([]);
//       return;
//     }
//     fetch(
//       `${FULL_API_BASE_URL}/get-city-list-serach_key/?search_key=${encodeURIComponent(
//         inputText
//       )}`
//     )
//       .then((response) => {
//         if (!response.ok) throw new Error("Network response was not ok");
//         return response.json();
//       })
//       .then((data) => {
//         setPermCityOptions(data);
//       })
//       .catch((error) => {
//         console.error("Error fetching permanent city list:", error);
//       });
//   };

//   const handleClickOutsidePerm = (event) => {
//     if (
//       searchPermCityRef.current &&
//       !searchPermCityRef.current.contains(event.target)
//     ) {
//       setFilteredPermCity([]);
//     }
//   };

//   // ADD THESE useEffect HOOKS after existing useEffect hooks
//   useEffect(() => {
//     document.addEventListener("click", handleClickOutside);
//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     document.addEventListener("click", handleClickOutsidePerm);
//     return () => {
//       document.removeEventListener("click", handleClickOutsidePerm);
//     };
//   }, []);

//   const handleGuardianChange = (e) => {
//     const { name, value } = e.target;
//     setGaurdianInfo((prevValues) => ({
//       ...prevValues,
//       [name]: value,
//     }));
//   };

//   const toggleGuardianAccordion = () => {
//     setIsGuardianOpen(!isGuardianOpen);
//   };

//   const handleGuardianDropdownChange = (fieldName, selectedOption) => {
//     setGaurdianInfo((prevValues) => ({
//       ...prevValues,
//       [fieldName]: selectedOption,
//     }));
//   };

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Student Registration</span>
//         <div className="cr-header-btn-container">
//         <button className="cr-cancel-btn" onClick={handleCancel}>
//           CANCEL
//         </button>
//         {isEditMode ? (
//           <button className="cr-create-btn" onClick={handleSubmit}>
//             SAVE
//           </button>
//         ) : (
//           <button className="cr-create-btn" onClick={() => setIsEditMode(true)} >
//             EDIT
//           </button>
//         )}
//       </div>
//       </div>
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>PERSONAL INFORMATION</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordion}>
//             {isOpen ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>
//         {/* {isOpen &&
//           classtypedata &&
//           statedata &&
//           coachingData &&
//           coursesdata &&
//           categorydata &&
//           genderdata &&
//           subcategorydata && ( */}
//           {isOpen &&
//             classtypedata?.length > 0 &&
//             statedata?.length > 0 &&
//             coachingData?.length > 0 &&
//             coursesdata?.length > 0 &&
//             categorydata?.length > 0 &&
//             genderdata?.length > 0 &&
//             subcategorydata?.length > 0 && (
//             <div className="accordion-content">
//               <div className="grid-container">
//                 <div className="item1">
//                   <FormInputs
//                     label="Enquiry Number"
//                     type="text"
//                     name="enquiry_id"
//                     value={personalInfo.enquiry_id}
//                     onChange={onChange}
//                     maxlength="50"
//                     pattern="[0-9]{1,50}"
//                     disabled
//                     bg="#d6d6d6"
//                   />
//                 </div>
//                 <div className="item2" style={{ position: "relative" }}>
//                   <FormInputs
//                     label="Student Roll Number"
//                     type="text"
//                     name="roll_number"
//                     value={personalInfo.roll_number}
//                     onChange={onChange}
//                     onBlur={handleRollNumberBlur}
//                     maxLength={10}
//                     pattern="[A-Za-z,0-9]{1,50}"
//                     required
//                     showError={showValidationErrors}
//                     disabled={studentIdFromUrl && !isEditMode}
//                   />
//                 </div>
//                 <div className="item3">
//                   <div className="selecte-dropdown-items">
//                      <SelectDropdown
//                         label="Class Type"
//                         selected={personalInfo.class_type_id}
//                         setSelected={(selectedOption) =>
//                           setPersonalInfo({ ...personalInfo, class_type_id: selectedOption })
//                         }
//                         options={[
//                           { label: "Online", id: 1 },
//                           { label: "Classroom", id: 2 },
//                         ]}
//                         isRequired={true}
//                         showError={showValidationErrors}
//                         disabled={studentIdFromUrl && !isEditMode}
//                       />
//                   </div>
//                 </div>
//                 <div className="item4">
//                   <FormInputs
//                     label="First Name"
//                     type="text"
//                     name="student_first_name"
//                     value={personalInfo.student_first_name}
//                     onChange={onChange}
//                     maxlength="50"
//                     pattern="[A-Za-z]{1,50}"
//                     required
//                     showError={showValidationErrors}
//                     disabled={studentIdFromUrl && !isEditMode}
//                   />
//                 </div>
//                 <div className="item5">
//                   <FormInputs
//                     label="Middle Name"
//                     type="text"
//                     name="student_middle_name"
//                     value={personalInfo.student_middle_name}
//                     onChange={onChange}
//                     maxlength="50"
//                     pattern="[A-Za-z]{1,50}"
//                     showError={showValidationErrors}
//                   />
//                 </div>
//                 <div className="item6">
//                   <FormInputs
//                     label="Last Name"
//                     type="text"
//                     name="student_last_name"
//                     value={personalInfo.student_last_name}
//                     onChange={onChange}
//                     maxlength="50"
//                     pattern="[A-Za-z]{1,50}"
//                   />
//                 </div>
//                 <div className="item7">
//                   <FormInputs
//                     label="Date of Birth"
//                     type="date"
//                     name="date_of_birth"
//                     value={personalInfo.date_of_birth}
//                     onChange={onChange}
//                     required
//                     showError={showValidationErrors}
//                     disabled={studentIdFromUrl && !isEditMode}
//                   />
//                 </div>
//                 <div className="item8">
//                   <div className="selecte-dropdown-items">
//                     <SelectDropdown
//                       label="Gender"
//                       selected={personalInfo.gender_id}
//                       setSelected={(selectedOption) => {
//                         const gender = genderdata.find(g => g.gender_id === selectedOption);
//                         setSelectedGenderName(gender?.gender_name || "");
//                         setPersonalInfo({ ...personalInfo, gender_id: selectedOption })
//                       }}
//                       options={genderdata.map((gender) => ({
//                         label: gender.gender_name,
//                         id: gender.gender_id,
//                       }))}
//                       isRequired={true}
//                       showError={showValidationErrors}
//                       disabled={studentIdFromUrl && !isEditMode}
//                     />
//                   </div>
//                 </div>
//                 <div className="item9">
//                   <FormInputs
//                     label="Aadhar Number"
//                     type="text"
//                     name="aadhaar_no"
//                     value={personalInfo.aadhaar_no}
//                     onChange={onChange}
//                     pattern="[0-9]{12}"
//                     maxLength={12}
//                   />
//                 </div>
//                 <div className="item10">
//                   <div className="selecte-dropdown-items">
//                      <SelectDropdown
//                         label="Category"
//                         selected={personalInfo.category_id}
//                         setSelected={(selectedOption) => {
//                           const category = categorydata.find(c => c.category_id === selectedOption);
//                           setSelectedCategoryName(category?.category_desc || "");
//                           setPersonalInfo({ ...personalInfo, category_id: selectedOption })
//                         }}
//                         options={categorydata.map((cat) => ({
//                           label: cat.category_desc,
//                           id: cat.category_id,
//                         }))}
//                         isRequired={true}
//                         showError={showValidationErrors}
//                         disabled={studentIdFromUrl && !isEditMode}
//                       />
//                   </div>
//                 </div>
//                 <div className="item11">
//                   <div className="selecte-dropdown-items">
//                     <SelectDropdown
//                       label="Sub Category"
//                       selected={personalInfo.sub_category_id}
//                       setSelected={(selectedOption) => {
//                         const subCategory = subcategorydata.find(s => s.sub_category_id === selectedOption);
//                         setSelectedSubCategoryName(subCategory?.sub_category_desc || "");
//                         setPersonalInfo({ ...personalInfo, sub_category_id: selectedOption })
//                       }}
//                       options={subcategorydata.map((subcat) => ({
//                         label: subcat.sub_category_desc,
//                         id: subcat.sub_category_id,
//                       }))}
//                       isRequired={true}
//                       showError={showValidationErrors}
//                       disabled={studentIdFromUrl && !isEditMode}
//                     />
//                   </div>
//                 </div>
//                 <div className="item12" style={{ gridRowStart: "4", gridRowEnd: "8", gridColumnStart: "3", gridColumnEnd: "3", }} >
//                   <div style={{ width: "100%" }}>
//                     <label>Photograph</label>
//                     <div className="input-image">
//                       <div className="input-image-field">
//                         <input
//                           type="file"
//                           accept="image/*"
//                           name="photograph"
//                           className="input-field"
//                           hidden
//                           onChange={handleImageChange}
//                         />
//                         {!showCropper ? (
//                           <>
//                             {image ? (
//                               <div
//                                 style={{
//                                   width: "200px",
//                                   height: "200px",
//                                   overflow: "hidden",
//                                   border: "1px solid #ccc",
//                                   borderRadius: "4px",
//                                 }}
//                               >
//                                 <img
//                                   className="uploaded-img"
//                                   src={image}
//                                   alt={fileName}
//                                   style={{
//                                     width: "100%",
//                                     height: "100%",
//                                     objectFit: "cover",
//                                   }}
//                                 />
//                               </div>
//                             ) : (
//                               <div className="icon-img-container">
//                                 <img
//                                   src={UploadImgIcon}
//                                   alt="upload icon"
//                                   className="icon-img"
//                                 />
//                               </div>
//                             )}
//                           </>
//                         ) : (
//                           <div style={{ position: "relative", width: "100%", height: "300px", }} >
//                             <CropperModal src={src} cropperRef={cropperRef} />
//                           </div>
//                         )}
//                       </div>
//                       <div className="image-btns-container">
//                         {showCropper ? (
//                           <>
//                             <div className="replace-image-btn" style={{ marginBottom: "10px" }} onClick={handleCropComplete} >
//                               Save Changes
//                             </div>
//                             <div className="replace-image-btn" onClick={() => document.querySelector(".input-field").click() } >
//                               Replace
//                             </div>
//                             <div className="del-image-btn" onClick={handleDeleteImage} > Delete </div>
//                           </>
//                         ) : (
//                           <>
//                             <div className="replace-image-btn" onClick={() => document.querySelector(".input-field").click() } >
//                               {image ? "Replace" : "Upload"}
//                             </div>
//                             {image && (
//                               <div className="del-image-btn" onClick={handleDeleteImage} >
//                                 Delete
//                               </div>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="item13">
//                   <div className="selecte-dropdown-items">
//                     <div>
//                       <SearchSelectedValues
//                         initialOptions={statedata || []}
//                         onSelect={handleStateSelect}
//                         placeholder="Type to search..."
//                         label="Domicile State"
//                         labelKey={(option) => option.state_name}
//                         initialValue={statedata?.find(s => s.state_id === personalInfo.domicile_city_id)?.state_name || ""}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="item14">
//                   <FormInputs
//                     label="Mobile Number"
//                     type="text"
//                     name="student_mob_no"
//                     value={personalInfo.student_mob_no}
//                     onChange={onChange}
//                     pattern="[0-9]{10,11}"
//                     maxLength={10}
//                     required
//                     showError={showValidationErrors}
//                     disabled={studentIdFromUrl && !isEditMode}
//                   />
//                 </div>
//                 <div className="item15">
//                   <FormInputs
//                     label="Student Email ID"
//                     type="email"
//                     name="email_id"
//                     value={personalInfo.email_id}
//                     onChange={onChange}
//                     pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{{2,}}"
//                   />
//                 </div>
//                 <div className="item16">
//                   <FormInputs
//                     label="Emergency Contact Number"
//                     type="text"
//                     name="emrgency_contact_mob_no"
//                     value={personalInfo.emrgency_contact_mob_no}
//                     onChange={onChange}
//                     pattern="[0-9]{10,11}"
//                     maxLength={10}
//                     required
//                     showError={showValidationErrors}
//                     disabled={studentIdFromUrl && !isEditMode}
//                   />
//                 </div>
//                 <div className="item17">
//                   <div className="selecte-dropdown-items">
//                       <SelectDropdown
//                         label="Course"
//                         selected={personalInfo.course_id}
//                         setSelected={(selectedOption) => {
//                           const course = coursesdata.find(c => c.course_id === selectedOption);
//                           setSelectedCourseName(course?.course_description || "");
//                           setPersonalInfo({ ...personalInfo, course_id: selectedOption })
//                         }}
//                         options={coursesdata.map((course) => ({
//                           label: course.course_description,
//                           id: course.course_id,
//                         }))}
//                         isRequired={true}
//                         showError={showValidationErrors}
//                         disabled={studentIdFromUrl && !isEditMode}
//                       />
//                   </div>
//                 </div>
//                 <div className="item12">
//                   <div className="selecte-dropdown-items">
//                      <SelectDropdown
//                         label="Previous coaching"
//                         selected={personalInfo.last_coaching_id}
//                         setSelected={(selectedOption) => {
//                           const coaching = coachingData.find(c => c.institute_id === selectedOption);
//                           setSelectedPreviousCoachingName(coaching?.institute_name || "");
//                           setSelectedCoachingName(coaching?.institute_name || "");
//                           setPersonalInfo({ ...personalInfo, last_coaching_id: selectedOption })
//                         }}
//                         options={coachingData.map((coach) => ({
//                           label: coach.institute_name,
//                           id: coach.institute_id,
//                         }))}
//                         Height="auto"
//                         OverFlow="auto"
//                         minheight="300px"
//                       />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}
//       </div>
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>EDUCATION DETAIL</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleEducationAccordion}>
//             {isEduOpen ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>
//         {isEduOpen && schoolnamedata && classData && mediumData && boardData && (
//           <div className="accordion-content">
//             <div className="grid-container-education">
//               <div className="selecte-dropdown-items">
//                <SearchSelectedSchool
//                   onSchoolSelect={handleSchoolSelect}
//                   showError={showValidationErrors}
//                   isRequired={true}
//                   initialValue={selectedSchoolName}
//                   disabled={studentIdFromUrl && !isEditMode}
//                 />
//               </div>
//               <div className="grid-item">
//                 <div className="selecte-dropdown-items">
//                   <SelectDropdown
//                     label="Class"
//                     selected={educationDetails.current_class_id}
//                     setSelected={(selectedOption) => {
//                       const classItem = classData.find(cls => cls.class_id === selectedOption);
//                       setSelectedClassName(classItem?.class_name || "");
//                       setEducationDetails((prevInfo) => ({
//                         ...prevInfo,
//                         current_class_id: selectedOption,
//                       }))
//                     }}
//                     options={classData.map((cls) => ({
//                       label: cls.class_name,
//                       id: cls.class_id,
//                     }))}
//                     isRequired={true}
//                     placeholder="Enter class"
//                     showError={showValidationErrors}
//                     disabled={studentIdFromUrl && !isEditMode}
//                   />
//                 </div>
//               </div>
//               <div className="grid-item">
//                 <div className="selecte-dropdown-items">
//                    <SelectDropdown
//                     label="Medium of education"
//                     selected={educationDetails.education_medium_id}
//                     setSelected={(selectedOption) => {
//                       const medium = mediumData.find(med => med.medium_id === selectedOption);
//                       setSelectedMediumName(medium?.medium_desc || "");
//                       setEducationDetails((prevInfo) => ({
//                         ...prevInfo,
//                         education_medium_id: selectedOption,
//                       }))
//                     }}
//                     options={mediumData.map((med) => ({
//                       label: med.medium_desc,
//                       id: med.medium_id,
//                     }))}
//                     isRequired={true}
//                     showError={showValidationErrors}
//                     disabled={studentIdFromUrl && !isEditMode}
//                   />
//                 </div>
//               </div>
//             </div>
//             <span className="academic-recod-title">Academic record:</span>
//               <div className="academic-recode-container">
//                 <div className="academic-tile">CLASS</div>
//                 <div className="academic-tile">BOARD</div>
//                 <div className="academic-tile">YEAR</div>
//                 <div className="academic-tile">SCHOOL NAME</div>
//                 <div className="academic-tile">%</div>

//               {[5, 6, 7, 8, 9, 10, 11, 12].map((classNum) => (
//                 <React.Fragment key={classNum}>
//                   <div className="class-name">{classNum === 5 ? 'V' : classNum === 6 ? 'VI' : classNum === 7 ? 'VII' : classNum === 8 ? 'VIII' : classNum === 9 ? 'IX' : classNum === 10 ? 'X' : classNum === 11 ? 'XI' : 'XII'}</div>
//                   <div className="data">
//                     <div className="selecte-dropdown-items">
//                       <SelectDropdown
//                         selected={educationDetails[`board_id_${classNum}`]}
//                         setSelected={(selectedOption) =>
//                           setEducationDetails((prevInfo) => ({
//                             ...prevInfo,
//                             [`board_id_${classNum}`]: selectedOption,
//                           }))
//                         }
//                         options={boardData.map((bod) => ({
//                           label: bod.edu_board_name,
//                           id: bod.edu_board_id,
//                         }))}
//                       />
//                     </div>
//                   </div>
//                   <div className="data">
//                     <FormInputs
//                       type="text"
//                       name={`pass_year_${classNum}`}
//                       value={educationDetails[`pass_year_${classNum}`] || ''}
//                       onChange={handleEducationChange}
//                       maxLength={4}
//                     />
//                   </div>
//                   <div className="data">
//                     <FormInputs
//                       type="text"
//                       name={`school_name_${classNum}`}
//                       value={educationDetails[`school_name_${classNum}`] || ''}
//                       onChange={handleEducationChange}
//                       pattern="[A-Za-z, ]{1,50}"
//                     />
//                   </div>
//                   <div className="data">
//                     <FormInputs
//                       type="text"
//                       name={`percentage_cgpa_${classNum}`}
//                       value={educationDetails[`percentage_cgpa_${classNum}`] || ''}
//                       onChange={handleEducationChange}
//                       maxLength={2}
//                       pattern="[0-9]{1,50}"
//                     />
//                   </div>
//                 </React.Fragment>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>ADDRESSES</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAddressAccordion}>
//             {isAddressOpen ? <div className="minus" /> : <div className="plus">+</div>}
//           </div>
//         </div>
//         {isAddressOpen && (
//           <div className="accordion-content">
//             <div className="address-info">
//               <div>
//                 <FormInputs
//                   label="Local Address"
//                   type="text"
//                   name="loc_add1"
//                   value={address.loc_add1 || ""}
//                   onChange={handleAddressChange}
//                   placeholder="Address line 1"
//                   maxlength="200"
//                   pattern="[A-Za-z0-9-, ]{1,200}"
//                   required
//                   showError={showValidationErrors}
//                   disabled={studentIdFromUrl && !isEditMode}
//                 />
//               </div>
//               <div>
//                 <FormInputs
//                   type="text"
//                   name="loc_add2"
//                   value={address.loc_add2 || ""}
//                   onChange={handleAddressChange}
//                   placeholder="Address line 2"
//                   maxlength="200"
//                   pattern="[A-Za-z0-9-, ]{1,200}"
//                   disabled={studentIdFromUrl && !isEditMode}
//                 />
//               </div>
//               <div className="grid-container-address">
//                 <div className="selecte-dropdown-items">
//                   <SearchSelectedValues
//                     initialOptions={localCityOptions}
//                     onInputChange={fetchLocalCityOptions}
//                     onSelect={(option) => {
//                       if (option) {
//                         setSelectedCity(option);
//                         setStateName(option.state_name);
//                         setSelectedLocalCityName(option.city_name);
//                         setAddress((prev) => ({
//                           ...prev,
//                           loc_city_id: option.city_id,
//                         }));
//                       } else {
//                         setSelectedCity(null);
//                         setStateName("");
//                         setAddress((prev) => ({
//                           ...prev,
//                           loc_city_id: 0,
//                         }));
//                       }
//                     }}
//                     placeholder="Search..."
//                     label="City/District"
//                     labelKey={(option) => option.city_name}
//                     required={true}
//                     showError={showValidationErrors}
//                     initialValue={selectedLocalCityName}
//                     disabled={studentIdFromUrl && !isEditMode}
//                   />
//                 </div>
//                 <div className="grid-item">
//                   <FormInputs
//                     label="State"
//                     type="text"
//                     value={stateName}
//                     disabled={selectedCity !== null}
//                     required
//                     showError={showValidationErrors}
//                   />
//                 </div>
//                 <div className="grid-item">
//                   <FormInputs
//                     label="Pin Code"
//                     type="text"
//                     name="loc_pincode"
//                     value={address.loc_pincode || ""}
//                     onChange={handleAddressChange}
//                     maxLength={6}
//                     pattern="[0-9]{6}"
//                   />
//                 </div>
//               </div>
//               <div
//                 className="parmanent-add-checkbox"
//                 style={{ marginTop: "30px" }}
//               >
//                 <div style={{ position: "relative" }}>
//                   <div className="local-add-checkbox">
//                     <label>Same as Local Address</label>
//                     <input
//                       type="checkbox"
//                       checked={sameAsLocal}
//                       onChange={handleCheckboxChange}
//                       className="cr-custom-checkbox"
//                       disabled={studentIdFromUrl && !isEditMode}
//                     />
//                   </div>
//                   <FormInputs
//                     label="Permanent Address"
//                     type="text"
//                     name="perm_add1"
//                     value={address.perm_add1 || ""}
//                     onChange={handleAddressChange}
//                     placeholder="Address line 1"
//                     disabled={sameAsLocal}
//                     maxlength="200"
//                     pattern="[A-Za-z0-9-, ]{1,200}"
//                     required
//                     showError={showValidationErrors}
//                     disabled={studentIdFromUrl && !isEditMode}
//                   />
//                   <FormInputs
//                     type="text"
//                     name="perm_add2"
//                     value={address.perm_add2 || ""}
//                     onChange={handleAddressChange}
//                     placeholder="Address line 2"
//                     maxlength="200"
//                     pattern="[A-Za-z0-9-, ]{1,200}"
//                     disabled={sameAsLocal}
//                     disabled={studentIdFromUrl && !isEditMode}
//                   />
//                 </div>
//                 <div className="grid-container-address">
//                   <div className="selecte-dropdown-items">
//                     <SearchSelectedValues
//                       initialOptions={permCityOptions}
//                       selected={selectedPermCity}
//                       onInputChange={fetchPermCityOptions}
//                       onSelect={(option) => {
//                         if (option) {
//                           setSelectedPermCity(option);
//                           setStateNamePerm(option.state_name);
//                           setSelectedPermCityName(option.city_name);
//                           setAddress((prev) => ({
//                             ...prev,
//                             perm_city_id: option.city_id,
//                           }));
//                         } else {
//                           setSelectedPermCity(null);
//                           setStateNamePerm("");
//                           setAddress((prev) => ({
//                             ...prev,
//                             perm_city_id: 0,
//                           }));
//                         }
//                       }}
//                       placeholder="Search..."
//                       label="City/District"
//                       labelKey={(option) => option.city_name}
//                       required={true}
//                       showError={showValidationErrors}
//                       disabled={sameAsLocal}
//                       initialValue={selectedPermCityName}
//                       disabled={studentIdFromUrl && !isEditMode}
//                     />
//                   </div>
//                   <div className="grid-item">
//                     <FormInputs
//                       label="State"
//                       type="text"
//                       value={stateNamePerm}
//                       // disabled={selectedPermCity !== null}
//                       disabled={selectedPermCity !== null || sameAsLocal}
//                       required
//                       showError={showValidationErrors}
//                     />
//                   </div>
//                   <div className="grid-item">
//                     <FormInputs
//                       label="Pin Code"
//                       type="text"
//                       name="perm_pincode"
//                       value={address.perm_pincode || ""}
//                       onChange={handleAddressChange}
//                       maxLength={6}
//                       pattern="[0-9]{6}"
//                       disabled={sameAsLocal}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>GUARDIAN INFORMATION</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleGuardianAccordion}>
//             {isGuardianOpen ? (
//               <div className="minus" />
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>
//         {isGuardianOpen && (
//           <div className="accordion-content">
//             <div className="grid-container">
//               <div className="grid-item">
//                 <FormInputs
//                   label="Father's Name"
//                   type="text"
//                   name="fathers_name"
//                   value={gaurdianInfo.fathers_name}
//                   onChange={handleGuardianChange}
//                   maxlength={200}
//                   pattern="[A-Za-z ]{1,150}"
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Occupation"
//                   type="text"
//                   name="fathers_occupation"
//                   value={gaurdianInfo.fathers_occupation}
//                   onChange={handleGuardianChange}
//                   maxlength={15}
//                   pattern="[A-Za-z ]{1,50}"
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Designation"
//                   type="text"
//                   name="fathers_designation"
//                   value={gaurdianInfo.fathers_designation}
//                   onChange={handleGuardianChange}
//                   maxlength={15}
//                   pattern="[A-Za-z ]{1,50}"
//                 />
//               </div>
//               <div className="grid-item">
//                 <div className="selecte-dropdown-items">
//                    <SelectDropdown
//                       label="Annual Income"
//                       selected={gaurdianInfo.fathers_annual_income}
//                       setSelected={(selectedOption) => {
//                         const incomeOption = [
//                           { label: "0 To Rs 2,00,000", id: "1" },
//                           { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
//                           { label: "Rs 400000 To Rs 6,00,000", id: "3" },
//                           { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
//                           { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
//                           { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
//                           { label: "> Rs 15,00,000", id: "7" },
//                           { label: "Not Available", id: "8" },
//                         ].find(income => income.id === selectedOption);

//                         setSelectedFatherIncomeName(incomeOption?.label || "");
//                         handleGuardianDropdownChange("fathers_annual_income", selectedOption);
//                       }}
//                       options={[
//                         { label: "0 To Rs 2,00,000", id: "1" },
//                         { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
//                         { label: "Rs 400000 To Rs 6,00,000", id: "3" },
//                         { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
//                         { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
//                         { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
//                         { label: "> Rs 15,00,000", id: "7" },
//                         { label: "Not Available", id: "8" },
//                       ]}
//                     />
//                 </div>
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Email ID"
//                   type="email"
//                   name="fathers_email_id"
//                   value={gaurdianInfo.fathers_email_id}
//                   onChange={handleGuardianChange}
//                   pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Mobile Number"
//                   type="text"
//                   name="fathers_mob_no"
//                   value={gaurdianInfo.fathers_mob_no}
//                   onChange={handleGuardianChange}
//                   pattern="[0-9]{10,11}"
//                   maxLength={10}
//                 />
//               </div>
//               <div className="grid-item" style={{ marginTop: "40px" }}>
//                 <FormInputs
//                   label="Mother's Name"
//                   type="text"
//                   name="mothers_name"
//                   value={gaurdianInfo.mothers_name}
//                   onChange={handleGuardianChange}
//                   maxlength={200}
//                   pattern="[A-Za-z ]{1,50}"
//                 />
//               </div>
//               <div className="grid-item" style={{ marginTop: "40px" }}>
//                 <FormInputs
//                   label="Occupation"
//                   type="text"
//                   name="mothers_occupation"
//                   value={gaurdianInfo.mothers_occupation}
//                   onChange={handleGuardianChange}
//                   maxlength={15}
//                   pattern="[A-Za-z ]{1,50}"
//                 />
//               </div>
//               <div className="grid-item" style={{ marginTop: "40px" }}>
//                 <FormInputs
//                   label="Designation"
//                   type="text"
//                   name="mothers_designation"
//                   value={gaurdianInfo.mothers_designation}
//                   onChange={handleGuardianChange}
//                   maxlength={15}
//                   pattern="[A-Za-z ]{1,50}"
//                 />
//               </div>
//               <div className="grid-item">
//                 <div className="selecte-dropdown-items">
//                   <SelectDropdown
//                     label="Annual Income"
//                     selected={gaurdianInfo.mothers_annual_income}
//                     setSelected={(selectedOption) => {
//                       const incomeOption = [
//                         { label: "0 To Rs 2,00,000", id: "1" },
//                         { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
//                         { label: "Rs 400000 To Rs 6,00,000", id: "3" },
//                         { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
//                         { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
//                         { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
//                         { label: "> Rs 15,00,000", id: "7" },
//                         { label: "Not Available", id: "8" },
//                       ].find(income => income.id === selectedOption);

//                       setSelectedIncomeName(incomeOption?.label || "");
//                       handleGuardianDropdownChange("mothers_annual_income", selectedOption);
//                     }}
//                     options={[
//                       { label: "0 To Rs 2,00,000", id: "1" },
//                       { label: "Rs 2,00,000 To Rs 4,00,000", id: "2" },
//                       { label: "Rs 400000 To Rs 6,00,000", id: "3" },
//                       { label: "Rs 6,00,000 To Rs 8,00,000", id: "4" },
//                       { label: "Rs 8,00,000 To Rs 10,00,000", id: "5" },
//                       { label: "Rs 10,00,000 To Rs 15,00,000", id: "6" },
//                       { label: "> Rs 15,00,000", id: "7" },
//                       { label: "Not Available", id: "8" },
//                     ]}
//                   />
//                 </div>
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Email ID"
//                   type="email"
//                   name="mothers_email_id"
//                   value={gaurdianInfo.mothers_email_id}
//                   onChange={handleGuardianChange}
//                   maxlength={150}
//                   pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Mobile Number"
//                   type="text"
//                   name="mothers_mob_no"
//                   value={gaurdianInfo.mothers_mob_no}
//                   onChange={handleGuardianChange}
//                   pattern="[0-9]{10,11}"
//                   maxLength={10}
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Guardian Name"
//                   type="text"
//                   name="guardian_name"
//                   value={gaurdianInfo.guardian_name}
//                   onChange={handleGuardianChange}
//                   maxlength={200}
//                   pattern="[A-Za-z, ]{1,50}"
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Guardian's Mobile Number"
//                   type="text"
//                   name="guardian_mob_no"
//                   value={gaurdianInfo.guardian_mob_no}
//                   onChange={handleGuardianChange}
//                   pattern="[0-9]{10,11}"
//                   maxLength={10}
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Guardian's Relation"
//                   type="text"
//                   name="guardian_relation"
//                   value={gaurdianInfo.guardian_relation || ""}
//                   onChange={handleGuardianChange}
//                   pattern="[0-9]{0,4}"
//                   maxLength={4}
//                 />
//               </div>
//               <div className="comments">
//                 <label>Comments</label>
//                 <textarea
//                   name="comments_"
//                   value={gaurdianInfo.comments_}
//                   style={{color: "#6A6A6A", fontSize: "14px"}}
//                   onChange={handleGuardianChange}
//                   placeholder="Write your comment here..."
//                   maxLength={500}
//                 />
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>CUSTOM FIELDS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleCustomAccordion}>
//             {isCustomOpen ? (
//               <div className="minus"></div>
//             ) : (
//               <div className="plus">+</div>
//             )}
//           </div>
//         </div>
//         {isCustomOpen && (
//           <div className="accordion-content">
//             <div className="grid-container">
//               <div className="grid-item">
//                 <FormInputs
//                   label="Custom Field 1"
//                   type="text"
//                   name="custom_field_1"
//                   value={customFields.custom_field_1}
//                   onChange={onCustomFieldChange}
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Custom Field 2"
//                   type="text"
//                   name="custom_field_2"
//                   value={customFields.custom_field_2}
//                   onChange={onCustomFieldChange}
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Custom Field 3"
//                   type="text"
//                   name="custom_field_3"
//                   value={customFields.custom_field_3}
//                   onChange={onCustomFieldChange}
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Custom Field 4"
//                   type="text"
//                   name="custom_field_4"
//                   value={customFields.custom_field_4}
//                   onChange={onCustomFieldChange}
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Custom Field 5"
//                   type="text"
//                   name="custom_field_5"
//                   value={customFields.custom_field_5}
//                   onChange={onCustomFieldChange}
//                 />
//               </div>
//               <div className="grid-item">
//                 <FormInputs
//                   label="Custom Field 6"
//                   type="text"
//                   name="custom_field_6"
//                   value={customFields.custom_field_6}
//                   onChange={onCustomFieldChange}
//                 />
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       <PreviewModal
//         isOpen={showPreviewModal}
//         onClose={() => setShowPreviewModal(false)}
//         data={{
//           personalInfo,
//           educationDetails,
//           address,
//           gaurdianInfo,
//           customFields,
//           imagePreview: image ,
//           courseName: selectedCourseName,
//           genderName: selectedGenderName,
//           categoryName: selectedCategoryName,
//           subCategoryName: selectedSubCategoryName,
//           coachingName: selectedCoachingName,
//           className: selectedClassName,
//           mediumName: selectedMediumName,
//           selectedIncomeName: selectedIncomeName,
//           selectedFatherIncomeName: selectedFatherIncomeName,
//           localCityName: selectedLocalCityName,
//           permCityName: selectedPermCityName,
//           previousCoachingName: selectedPreviousCoachingName
//         }}
//         onConfirm={handleConfirmSubmit}
//       />
//     </div>
//   );
// }

// export default StudentRegEdit;